import React from "react";
import { Badge, Button, Col, Form, InputGroup, Modal, OverlayTrigger, Row, Spinner, Table, Tooltip } from "react-bootstrap";
import './style.css'
import Fontstyling, {
  clientListDrpDwnStyles,
  isValidDate,
} from "../../../components/common/comman";
import CryptoJS from "crypto-js";
import { useState, useRef, useEffect } from "react";
import { FieldArray, Formik, useFormik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../components/common/CustomButton";
import DeleteModal from "../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../components/common/CustomMaterialTable";
import toastFile from "../../../Service/ToastFile";
import CustomInputField from "../../../components/common/CustomInputField";
import Required from "../../../components/Required";
import { useSelector } from "react-redux";
import deleteIcon from "../../../assets/icon/trash-solid.svg";
import {
  CreateBidderInfo,
  DeleteBidderInfo,
  DownloadFile,
  EmpowerxRfpCreate,
  EmpowerxRfpDelete,
  EmpowerxRfpUpdate,
  GetEmpoweRxDrugDiscountInRfp,
  GetEmpowerxBidFileRecord,
  GetListBidderInfo,
  GetListofEmpowerxRfp,
  GetPBMList,
  SubmitRfp,
  UpdateBidderInfo,
  DuplicateQuestionnarie,
  DeleteDuplicateQuestionnaire,
  GetEmpoweRxDrugDiscountByClientId,
} from "../../../api/EmpowRxApi";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import editIconWhite from "../../../assets/icon/pencil-fill-white.svg";
import deletIcon from "../../../assets/icon/trash-solid.svg";
import deletIconWhite from "../../../assets/icon/trash-solid-white.svg";
import ReactTooltip from "react-tooltip";
import { MdAddCircle } from "react-icons/md";
import { IoCheckmarkCircle, IoEyeOutline, IoCloseCircle, IoClose } from "react-icons/io5";
import { FaExternalLinkAlt, FaRegClone, FaTrash } from "react-icons/fa";
import { TbStar, TbStarFilled, TbStarOff } from "react-icons/tb";
import { GetStates } from "../../../api/ClinicalIntake/ClinicalIntakeApi";
import { toast } from "react-toastify";
import moment from "moment";
import { GetClientsDataByClientID } from "../../../api/User/ACG/clientDeatilApi";
import { GetHolidayDates, GetPresignedURL } from "../../../api/RFPSurveyApi";
import { ConfirmModal } from "../../../components/common/Modal/ConfirmModal";
import ReactSelect from "react-select";
import RfpAdditionalQuestions from "../../../components/EmpowRx/RfpAdditionalQuestions";

const schema = Yup.object().shape({
  pharmacyMarketing:Yup.string().trim().required("Please select pharmacy marketing option"),
  RFPReleaseDate: Yup.date().required("Please select release date"),
  RFPTitle: Yup.string().trim().required("Please enter rfp title"),
  client: Yup.object().nonNullable().required("Please select client name"),
  IncumbentPBM: Yup.string().required("Please enter incumbent pbm "),
  PrimaryContactInfo: Yup.string()
    .trim()
    .required("Please enter primary contact info"),
  PrimaryContactEmail: Yup.string()
  .required("Please enter primary contact email")
  .test("is-email-list-valid", "Invalid email address", (value) => {
    if (!value) return true;
    const emails = value?.split(";").map((email) => email.trim());
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emails.every((email) => emailRegex.test(email));
  }),
PrimaryContactPhone: Yup.string()
  .required("Please enter primary contact phone"),
SecondaryContactEmails: Yup.string().test(
  "is-email-list-valid",
  "Invalid email address",
  (value) => {
    if (!value) return true;
    const emails = value?.split(";").map((email) => email.trim());
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emails.every((email) => emailRegex.test(email));
  }
),
  GoalsforRFP: Yup.string().trim().required("Please enter goals for rfp"),
  ToleranceforChange: Yup.string()
    .trim()
    .required("Please enter tolerance for change"),
  VendorScope: Yup.string().trim().required("Please enter vendor scope"),
  ContractTermDate: Yup.date().required("Please select contract term date"),
  EstimatedTotalSpendperYear: Yup.number()
    .typeError("Please enter a valid number.")
    .min(0, "Spend limit cannot be below 0.")
    .nullable(),
    IncumbentMedicalCarrierTPA: Yup.string().trim().required("Please enter Incumbent Medical Carrier / TPA"),
    RxClaimsBeginningDate: Yup.date().required(
    "Please select rx claims beginning date"
  ),
  RxClaimsEndingDate: Yup.date().required(
    "Please select rx claims ending date"
  ),
  Members: Yup.number()
    .positive("Please enter positive number")
    .typeError("Please enter a valid number.")
    .required("Please enter #members"),
  RFPCompensationFee: Yup.number()
    .min(0,"Please enter positive number")
    .typeError("Please enter a valid number.")
    .required("Please enter compensation fee"),
  Employees: Yup.number()
    .positive("Please enter positive number")
    .typeError("Please enter a valid number.")
    .required("Please enter #employees"),
  MembershipDeductible: Yup.number()
    .min(0,"Please enter positive number")
    .typeError("Please enter a valid number.")
    .required("Please enter membership deductible"),
  PharmacyClaims: Yup.number()
    .min(0,"Please enter positive number")
    .typeError("Please enter a valid number.")
    .required("Please enter pharmacy claims"),
  Retail30Network: Yup.string().required("Please enter retail 30 network"),
  MailPharmacyProgram: Yup.string().required(
    "Please enter mail pharmacy program"
  ),
  SpecialtyPharmacyNetwork: Yup.string().required(
    "Please enter specialty pharmacy network"
  ),
  FormularyDrugListStrategy: Yup.string().required(
    "Please enter formulary drug list strategy"
  ),
  ClinicalPrograms: Yup.string().required("Please enter clinical programs"),
  AccumulatorAdjustmentProgram: Yup.string().required("Please enter Accumulator Adjustment Program"),
});

const addQuesModalSchema = Yup.object().shape({
  questionNumber: Yup.number()
  .positive("Please enter positive number")
  .typeError("Please enter a valid number.")
  .required("Please enter Question number"),
  questionLabel:Yup.string().trim().required("Please type a question"),
  questionType: Yup.string().required("Please select question type"),
  dropdownType: Yup.string()
  .when('questionType', {
    is: (val) => val && JSON.parse(val).label === "Drop-Down",
    then: (schema) => schema.required("Please select dropdown type"),
    otherwise: (schema) => schema.notRequired()
  }),
  dropdownValues: Yup.string()
  .when('questionType', {
    is: (val) => val && JSON.parse(val).label === "Drop-Down",
    then: (schema) => schema.required("Please enter dropdown values"),
    otherwise: (schema) => schema.notRequired()
  }),
  explanationRequired: Yup.string()
  .when('dropdownType', {
    is: (val) => val && JSON.parse(val).type === "dropdown",
    then: (schema) => schema.required("Please select is explanation required"),
    otherwise: (schema) => schema.notRequired()
  }),
  dropdownValuesRequireExplanation: Yup.string()
  .when('explanationRequired', {
    is: (val) => val && JSON.parse(val).label === "Yes",
    then: (schema) => schema.required("Please enter dropdown values for require explanation")
      .test(
        'dropdown-values-exist',
        'Drop-Down value(s) entered do not exist in Drop-Down Values field above.',
        function (value) {
          const { dropdownValues } = this.parent;
          const dropdownValuesArray = dropdownValues?.split(',').map(val => val.trim());
          const requireExplanationArray = value?.split(',').map(val => val.trim());

          return requireExplanationArray?.every(val => dropdownValuesArray?.includes(val));
        }
      ),
    otherwise: (schema) => schema.notRequired()
  }),
  isQuestionRequired: Yup.string().required("Please select is question required"),
});

function isWeekend(date) {
  const dayOfWeek = date.day();
  return dayOfWeek === 0 || dayOfWeek === 6;
}

function isHoliday(date, holidays) {
  return holidays?.includes(date.format("MM/DD/YYYY"));
}

function addBusinessDays(startDate, daysToAdd, holidays) {
  let currentDate = moment(startDate);
  while (daysToAdd > 0) {
    currentDate.add(1, "days");
    if (isWeekend(currentDate) || isHoliday(currentDate, holidays)) {
      continue;
    }
    daysToAdd--;
  }
  return currentDate;
}

const EmpoweRX = () => {
  const formikRef = useRef();
  const user = useSelector((state) => state.userDetails.value);
  const [showTable, setShowTable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState();
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isGetData, setIsGetData] = useState(false);
  const [pbmList, setPbmList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [bidderTableData, setBidderTableData] = useState([{}]);
  const [isExistingBidRes, setIsExistingBidRes] = useState(false);
  const inpRef = useRef(null);
  const [isDisable, setisDisable] = useState(false);
  const [RFPID, setRFPID] = useState(null)
  const [exsitingBidderInfoCSV, setExsitingBidderInfoCSV] = useState(null)
  const [SBCFile, setSBCFile] = useState(null)
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [bidderEdit, setBidderEdit] = useState({isEdit: false, editRowInd:-1});
  const [fileErrors, setFileErrors] = useState({sbcFile: false, sbcFileError:null, rxClaimFile: false, rxClaimFileError:null});
  const [holidays, setHolidays] = useState([]);
  const [medCarrTPADisabled, setMedCarrTPADisabled] = useState(false);
  const [empowrxDiscount, setEmpoweRxDiscount] = useState();
  const [empowrxDiscounts, setEmpoweRxDiscounts] = useState();
  const [pharmMaketingQuenDetail, setPharmMaketingQuenDetail] = useState([]);
  const [selectedBidderQuenModal, setSelectedBidderQuenModal] = useState({item: {}, index: -1});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [additionalQuesTableData, setAdditionalQuesTableData] = useState([]);
  const [showAddQuesModal, setShowAddQuesModal] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [showQuePreviewModal, setShowQuePreviewModal] = useState(false);
  const [showDeleteNewQueModal, setShowDeleteNewQueModal] = useState({
    isShowModal: false, confirmStep: 0 
  });
  const [isQuestionsShorted, setIsQuestionsShorted] = useState(false);
  const [initlValsAddNewQuesList, setInitlValsAddNewQuesList] = useState({
    needAdditionalQues: '',
    questions: [],
  });

  const [uniqueBidCompanies, setUniqueBidCompanies] = useState([]);
  const [showFinalWinnerConfirmModal, setShowFinalWinnerConfirmModal] = useState(false);
  const [showFinalistConfirmModal, setShowFinalistConfirmModal] = useState(false);
  const [canSaveFinalist, setCanSaveFinalist] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [errorPreventingModel,setErrorPreventingModel] = useState(false)
  const mainRFPFormikRef = useRef();
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);
  const formattedDate = currentDate.toISOString().split('T')[0];
  const isSubmitDisabled = useRef(true) ;
  const isSaveDisabled = useRef(false) ;
  const addNewQuesListFormikRef = useRef();
  const finalWinnerFormikRef = useRef();
  
  const column = [
    { title: "Title", field: "title" },
    { title: "Client Name", field: "clientName" },
    { title: "Last Updated Date", field: "lastUpdatedDate", type: "date" },
    {
      title: "Status",
      field: "status",
      render: (item) => {
        let status;
        let badgeColor;
        switch (item.status) {
          case "Pending":
            badgeColor = "warning";
            item.status = "Pending";
            break;
          case "Sent":
            badgeColor = "success";
            item.status = "Sent";
            break;
          case "Submitted":
            badgeColor = "primary";
            item.status = "Submitted";
            break;
          case "Declined":
            badgeColor = "dark";
            break;
        }
        return (
          <Badge
            pill
            className="fw-normal py-1 px-3"
            bg={badgeColor}
            style={{ fontSize: "10px" }}
          >
            {item.status? item.status : ""}
          </Badge>
        );
      },
    },
    {
      title: "Actions",
      minWidth: "74px",
      maxWidth: "75px",
      cellStyle: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
      sorting: false,
      render: (rowData) =>
        rowData.status !== "" ? (
          <>
            {rowData.status == "Sent" ? <IoEyeOutline
              width="11"
              className="m-2 cursor-pointer"
              style={{ fontSize: "15px" }}
              alt="show more rfp"
              onClick={() => {
                setWitchAction("showMoreRFP");
                setSelectedRowData(rowData);
                setShowModal(true);
                getBidderListInfo(rowData.id)
              }}
            /> : ""}
            {rowData.status == "Sent" ? <FaExternalLinkAlt 
              width="11"
              className="m-2 cursor-pointer"
              style={{ fontSize: "15px" }}
              alt="show more"
              onClick={() => {
                setWitchAction("showMore");
                setSelectedRowData(rowData);
                setShowMoreModal(true);
                getBidderListInfo(rowData.id, "showMore");
                setRFPID(rowData.id);
              }}
            /> : ""}
            {rowData.status == "Pending" ?
              <img
                src={
                  selectedRow === rowData.tableData.id ? editIconWhite : editIcon
                }

                width="11"
                className="m-2 cursor-pointer"
                alt="edit icon"
                onClick={() => {
                  setWitchAction("update");
                  setSelectedRowData(rowData);
                  setShowModal(true);
                }}
              />
              : ""}
            {rowData.status == "Pending" ? <img
              src={
                selectedRow === rowData.tableData.id ? deletIconWhite : deletIcon
              }

              width="11"
              className="m-2 cursor-pointer"
              alt="delete icon"
              onClick={() => {
                setWitchAction("delete");
                setSelectedRowData(rowData);
                getBidderListInfo(rowData.id)
                setShowModal(true);
              }}
            /> : ''}
          </>
        ) : (
          <div className="m-2" style={{ height: "11px", width: "11px" }}></div>
        ),
    },
  ];

  const columnBidder = [
    { title: "Client Name", field: "clientName" },
    { title: "Encrypted Member ID", field: "encryptedMemberID" },
    { title: "Plan Type", field: "planType" },
    { title: "Fill Date", field: "fillDate" },
    { title: "Dispense Location", field: "dispenseLocation" },
    { title: "Pharmacy ID", field: "pharmacyID" },
    { title: "Pharmacy Zip", field: "pharmacyZip" },
    { title: "Channel Indicator", field: "channelIndicator" },
    { title: "Metric Quantity", field: "metricQuantity" },
    { title: "Days Supply", field: "daysSupply" },
    { title: "NDC11", field: "ndC11" },
    { title: "Drug Name", field: "drugName" },
    { title: "Formulary Flag", field: "formularyFlag" },
    { title: "Formulary Tier", field: "formularyTier" },
    { title: "Preventive Drug Flag", field: "preventiveDrugFlag" },
    { title: "Bidder Name", field: "bidderName" },
    { title: "Dispensing Channel", field: "dispensingChannel" },
    { title: "Brand v. Generic Indicator", field: "brandvGenericIndicator" },
    { title: "Specialty Drug Indicator", field: "specialtyDrugIndicator" },
    { title: "Specialty Pharmacy Indicator", field: "specialtyPharmacyIndicator" },
    { title: "Guaranteed Claim or Excluded Claim (Ing. Cost & Disp. Fee)", field: "guaranteedClaimorExcludedClaim" },
    { title: "Exclusion Claim Type - Ing. Cost & Disp. Fee", field: "exclusionClaimType" },
    { title: "Guaranteed AWP-% Discount", field: "guaranteedAWPDiscount" },
    { title: "PBM Calculated Ingredient Cost", field: "pbmCalculatedIngredientCost" },
    { title: "Guaranteed Dispensing Fee", field: "guaranteedDispensingFee" },
    { title: "Guaranteed or Excluded Claims (Rebates)", field: "guaranteedorExcludedClaims" },
    { title: "Excluded Claim Type - Rebates", field: "excludedClaimTypeRebates" },
    { title: "Guaranteed Rebate Amount", field: "guaranteedRebateAmount" },
    { title: "Formulary Coverage Disruption Indicator", field: "formularyCoverageDisruptionIndicator" },
    { title: "Formulary Tier Disruption Indicator", field: "formularyTierDisruptionIndicator" },
    { title: "Preventive Disruption Indicator", field: "preventiveDisruptionIndicator" },
    { title: "Pharmacy Network Disruption", field: "pharmacyNetworkDisruption" },
    { title: "per Claim Admin Fee", field: "perClaimAdminFee" },
    { title: "per Claim Onsite Rx Fee", field: "perClaimOnsiteRxFee" }
  ];

  const getHoliday = async(date) => {
      await GetHolidayDates(moment(date).format("MM-DD-YYYY")).then((res) => {
        let holiday = res.data.data.map((item) =>
          moment(item?.date).format("MM/DD/YYYY")
        );
        setHolidays(holiday);
      })
      .catch((err)=>console.log(err))
  };
  console.log("Question number",addNewQuesListFormikRef?.current?.values?.questions.length + 1)

  useEffect(() => {
    if (showModal === false) {
      setRFPID(null);
      setSelectedRowData(null);
      setBidderTableData([{}]);
      setWitchAction('')
      setIsExistingBidRes(false);
      mainRFPFormikRef?.current?.resetForm()
      formikRef?.current?.resetForm();
      isSaveDisabled.current = false;
      isSubmitDisabled.current = true;
      setExsitingBidderInfoCSV(null)
      setSBCFile(null)
      setBidderEdit({isEdit:false, editRowInd:-1});
      setFileErrors({sbcFile: false, sbcFileError:null, rxClaimFile: false, rxClaimFileError:null})
      setMedCarrTPADisabled(false);
      setAdditionalQuesTableData([]);
      setInitlValsAddNewQuesList({needAdditionalQues:'', questions:[]});
      addNewQuesListFormikRef?.current?.resetForm();
    } else {
      if (witchAction === 'update') {
        getBidderListInfo(selectedRowData?.id)
        setRFPID(selectedRowData?.id);
        

      } else if(witchAction === 'showMoreRFP') {
        getAdditionalQuestionList();
      }
      getClientfromDrugdiscount();
    }
    if (isGetData) {
      setShowTable(true)
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    setisDisable(false)
    getPBMList();
    GetStates().then((res) => {
      setStateList(() =>
        res.data.sort((a, b) => a.state.localeCompare(b.state))
      );
    });
  }, []);

  const getClientfromDrugdiscount = async () =>{
      await GetEmpoweRxDrugDiscountInRfp(user.UD_id)
      .then((res)=>{
        setEmpoweRxDiscounts(res.data);
        let formatedData = res.data.map((obj) => {
          return { value: obj.clientId, label: obj.clientName };
        });
        setClientList(formatedData);
        selectedRowData?.clientId && onChangeClient(res.data, selectedRowData?.clientId, true);
      })
      .catch((error)=>{
        console.log(error)
      })
    }

  const checkFileSizelimit = (file) => {
    const fileSizeInMB = file.size / (1024 * 1024);
    console.log(file.size, fileSizeInMB)
    if (parseFloat(fileSizeInMB) > 60) {
      return false
    } else {
      return true
    }
  }
  
  const extractRfpidFromURL = (url) => {
    try {
      const parsedUrl = new URL(url);
      const searchParams = parsedUrl?.searchParams;
      return searchParams.get('r');
    } catch (error) {
      console.log("Invalid URL:", error);
      return null;
    }
  }


  const getClientData = (clientId, isUpdateModalLoading) => {
    GetClientsDataByClientID(user.UD_id, clientId ).then((res) => {
      if (res.status === 200) {
        let data = res.data[0];
        // console.log('data',data);
        if (data?.Main_Carriers) {
          mainRFPFormikRef?.current?.setFieldValue('IncumbentMedicalCarrierTPA', data?.Main_Carriers);
          setMedCarrTPADisabled(true);
        } else{
          if(!isUpdateModalLoading) {
            mainRFPFormikRef?.current?.setFieldValue('IncumbentMedicalCarrierTPA',"");
            setMedCarrTPADisabled(false);
          }
        }
      }
    });
  }; 
  
  const getPBMList = () => {
    GetPBMList()
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setPbmList(res.data.data);
        }
      })
      .catch((err) => console.log({ err }));
  };
  const getBidderListInfo = (rfpId, modalName) => {
    setIsLoading(true);
    GetListBidderInfo(rfpId)
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          let data = res.data.data;
          if (data.length > 0) {
            let _pharmMaketingQuenDetail = [];
            const bidderInfo = data?.map((el, ind) => {
              let dummyId = new Date().getTime();
              if(modalName === "showMore"){
                const rfpid = extractRfpidFromURL(el.surveyLink);
                _pharmMaketingQuenDetail.push({ ...el, rfpid });
              }
              return { ...el, dummyId: dummyId + ind };
            });
            setBidderTableData([...bidderInfo]);
            setPharmMaketingQuenDetail([..._pharmMaketingQuenDetail]);
            if(modalName === "showMore"){
              let _canSaveFinalist = data.some(el=> !el.finalist && el.surveyStatus !== "Declined");
              setCanSaveFinalist(_canSaveFinalist);
            }

            let uniqeuBidComp = [
              ...new Map(bidderInfo.map((obj) => [obj["bidderCompanyName"], obj["bidderCompanyName"]])).values(),
            ];
            setUniqueBidCompanies(uniqeuBidComp);
          } else {
            setBidderTableData([{}]);
          }
        }else {
          toastFile("Failed to get bidder information detail")
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  }

  const createEmpowerxBidInfoSingle = async (item) => {
    setBidderEdit((prev=>({...prev,isEdit:false})))
    const created = new Date().toISOString();
    const encryptData = CryptoJS.AES.encrypt(
      JSON.stringify(RFPID),
      process.env.REACT_APP_AES_KEY
    ).toString();

    const enc_surveyID = CryptoJS.AES.encrypt(
      JSON.stringify(item?.surveyId),
      process.env.REACT_APP_AES_KEY
    ).toString();
    const enc_link = CryptoJS.AES.encrypt(
      JSON.stringify(`rfpid=${encryptData}&surveyid=${enc_surveyID}`),
      process.env.REACT_APP_AES_KEY
    ).toString();
    const surveyLink = `${process.env.REACT_APP_API}/Questionnaire/home?r=${enc_link}`;
    let payload = {
      id: 0,
      rfpid: +RFPID,
      surveyID: item.surveyId,
      surveyLink: surveyLink,
      surveyStatus: item.surveyStatus,
      bidderCompanyName: item.bidderCompanyName,
      bidderContactName: item.bidderContactName,
      bidderContactEmail: item.bidderContactEmail,
      bidderContactPhone: item.bidderContactPhone,
      jobTitle: item.jobTitle,
      mailingAddress: item.mailingAddress,
      city: item.city,
      state: item.state,
      zip: item.zip,
      created: created
    };
    

    try {
      const res = await CreateBidderInfo(payload);
      if (res?.status === 200) {
        getBidderListInfo(RFPID);
      }
      else {
        toastFile("Failed to add bidder info.")
        setBidderEdit((prev=>({...prev,isEdit:false})))
        return true;
      }
    } catch (error) {
      console.log("Error:", error);
   }
  }

  const createEmpowerxBidInfo = async (refID) => {
    try {
      const currentDate = new Date().toISOString();
      const encryptData = CryptoJS.AES.encrypt(
        JSON.stringify(refID),
        process.env.REACT_APP_AES_KEY
      ).toString();

      const payloads = bidderTableData.filter(el => el?.id === 0).map(item => {
        const enc_surveyID = CryptoJS.AES.encrypt(
          JSON.stringify(item?.surveyId),
          process.env.REACT_APP_AES_KEY
        ).toString();
        const enc_link =  CryptoJS.AES.encrypt(
          JSON.stringify(`rfpid=${encryptData}&surveyid=${enc_surveyID}`),
          process.env.REACT_APP_AES_KEY
        ).toString();
        const surveyLink = `${process.env.REACT_APP_API}/Questionnaire/home?r=${enc_link}`;
        const createdDate = currentDate;
        return {
          id: 0,
          rfpid: +refID,
          surveyID: item.surveyId,
          surveyLink: surveyLink,
          surveyStatus: item.surveyStatus,
          bidderCompanyName: item.bidderCompanyName,
          bidderContactName: item.bidderContactName,
          bidderContactEmail: item.bidderContactEmail,
          bidderContactPhone: item.bidderContactPhone,
          jobTitle: item.jobTitle,
          mailingAddress: item.mailingAddress,
          city: item.city,
          state: item.state,
          zip: item.zip,
          created: createdDate
        };
      });
      if (payloads?.length > 0) {
        const apiCalls = payloads.map(payload => CreateBidderInfo(payload));
        const results = await Promise.all(apiCalls);
        results.map(result => {
          if (result?.status !== 200) {
            isSubmitDisabled.current = true;
            toastFile("Failed to add bidder info.")
            // setShowModal(false);
          }else if (!isSubmitDisabled.current){
            isSubmitDisabled.current = false;
          }
        })       
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  const updateEmpowerxBidInfo = async (item) => {
    setBidderEdit((prev=>({...prev,isEdit:false})))
    let payload = {
      id: item.id,
      rfpid: +RFPID,
      surveyID: item.surveyID,
      surveyLink: item.surveyLink,
      surveyStatus: item.surveyStatus,
      bidderCompanyName: item.bidderCompanyName,
      bidderContactName: item.bidderContactName,
      bidderContactEmail: item.bidderContactEmail,
      bidderContactPhone: item.bidderContactPhone,
      jobTitle: item.jobTitle,
      mailingAddress: item.mailingAddress,
      city: item.city,
      state: item.state,
      zip: item.zip,
      finalist: item.finalist,
      finalistDate: item.finalistDate,
      created: item.created
    };
    try {
      const res = await UpdateBidderInfo(payload);
      if (res?.status === 200) {

      }
      else {
        toastFile("Failed to update bidder info.");
        setBidderEdit((prev=>({...prev,isEdit:true})))
        return true;
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  const getEmpowerxBidFileRecord = (clientName, startDate, endDate) => {
    const encodedClientName = encodeURIComponent(clientName);
    GetEmpowerxBidFileRecord(encodedClientName, startDate, endDate)
      .then((res) => {
        let data = res?.data?.data;
        if (data?.length > 0) {
          let updatedData = data.map((item)=>({
            ...item,
            fillDate:moment(item.fillDate).format("MM/DD/YYYY")
          }))
          downloadExisBidFileInBg(updatedData, "Existing_Bidder_Response.csv");
          setIsExistingBidRes(true);
        } else {
        }
      })
      .catch((error) => {
        console.log("Error fetching data:", error);
      });
  };

  const deleteEmpowerxBidInfo = async (id) => {
    try {
      const res = await DeleteBidderInfo(id);
      if (res?.status === 200) {

      }
      else {
        toastFile("Failed to delete bidder info.")
        return true;
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };
  
  const prepareRFPPayload = (values)=> {
    let payload = {
      id: +(selectedRowData?.id ?? RFPID ?? 0),
      title: values.RFPTitle,
      clientName: values.client.label,
      clientId: values.client.value,
      incumbentPBM: JSON.parse(values?.IncumbentPBM).Name,
      releaseDate: values.RFPReleaseDate,
      dueDate: values.RFPDueDate,
      reviewDate: values.RFPReviewDate,
      qaDate: values.QADate,
      primaryContactInfo: values.PrimaryContactInfo,
      primaryContactEmail: values.PrimaryContactEmail,
      primaryContactPhone: values.PrimaryContactPhone,
      secondaryContactEmail: values.SecondaryContactEmails,
      rfpGoal: values.GoalsforRFP,
      toleranceForChange: values.ToleranceforChange,
      vendorScope: values.VendorScope,
      contractTermDate: values.ContractTermDate,
      incumbentMedicalCarrier: values.IncumbentMedicalCarrierTPA,
      estimatedTotalSpendperYear: +values.EstimatedTotalSpendperYear,
      rxClaimsBeginningDate: values.RxClaimsBeginningDate,
      rxClaimsEndingDate: values.RxClaimsEndingDate,
      noofMembers: +values.Members,
      rfpCompenSationFee: +values.RFPCompensationFee,
      noofEmployees: +values.Employees,
      membershipPercentHighDeductibleHealthPlan: +values.MembershipDeductible,
      pharmacyClaimPaidPercentageHighDeductHealthPlan: +values.PharmacyClaims,
      retail30Network: values.Retail30Network,
      retail90Network: values.Retail90Value !== ''? 'Yes' : 'No',
      mailPharmacyProgram: values.MailPharmacyProgram,
      specialtyPharmacyNetwork: values.SpecialtyPharmacyNetwork,
      formularyDrugListStrategy: values.FormularyDrugListStrategy,
      clinicalPrograms: values.ClinicalPrograms,
      specialtyCopayCard: values.SpecialtyCopayCard,
      patientAssistanceProgram: values.PatientAssistanceProgram,
      accumulatorAdjustmentProgram: values.AccumulatorAdjustmentProgram,
      onsitePharmacyID:values.OnsitePharmacyID,
      status: selectedRowData?.status ?? "Pending",
      lastUpdatedDate: new Date().toISOString(),
      hubEmail: user?.UD_emp_email,
      pharmacyMarketingOption: values.pharmacyMarketing,
      userEmail:user?.UD_emp_email,
      userName:user?.UD_emp_name,
      retail90:values.Retail90Value,
      hospitalHealthSystemFile:empowrxDiscount?.hospitalHealthSystemRequirementQuestionnaireFileUrl ? empowrxDiscount?.hospitalHealthSystemRequirementQuestionnaireFileUrl : null,
      isAdditionalQuestions: values.isAdditionalQuestions ?? selectedRowData?.isAdditionalQuestions ?? "No",
      additionalQuestionsList: values.additionalQuestionsList ?? selectedRowData?.additionalQuestionsList ?? "",
      additionalQuestions: values.additionalQuestions ?? selectedRowData?.additionalQuestions ?? "",
      finalWinnerCompanyName: values.finalWinnerCompanyName ?? "",
      censusRecordFile: selectedRowData?.censusRecordFile ?? null,
      sbcFile: selectedRowData?.sbcFile ?? null,
      rxClaimDataFile: selectedRowData?.rxClaimDataFile ?? null,
      empowerxDrugDiscountId:empowrxDiscount?.id
    };
    return payload;
  }

  const handleActions = async (values) => {
    if (Object.keys(formikRef.current?.errors)?.length > 0) {
      isSaveDisabled.current = false;
      return;
    }
    isSaveDisabled.current = true;
    setShowTable(false);
    let payload = prepareRFPPayload(values);
    if (witchAction === "add") {
      setIsGetData(true);
      try {
        const res = await EmpowerxRfpCreate(payload);
        if (res?.status === 200) {
          isSubmitDisabled.current = false
          toastFile("new");
          createEmpowerxBidInfo(res?.data?.data);
          setRFPID(res?.data?.data);
          getEmpowerxBidFileRecord(values.client.label, values?.RxClaimsBeginningDate, values?.RxClaimsEndingDate);
        }
        else{
          isSubmitDisabled.current = true;
          setShowModal(false);
          toastFile("Failed to create pharmacy marketing request.")
          }
      } finally {
        setShowTable(true);
        setBidderEdit({isEdit: false, editRowInd:-1});
      }
    } else if (witchAction === "update") {
      setIsGetData(true);
      try {
        const res = await EmpowerxRfpUpdate(payload);
        if (res?.status === 200) {
          isSubmitDisabled.current = false
          toastFile("update");
          getEmpowerxBidFileRecord(
            values?.client.label,
            values?.RxClaimsBeginningDate,
            values?.RxClaimsEndingDate
          );
        }else{
        isSubmitDisabled.current = true;
        setShowModal(false);
        toastFile("Failed to update pharmacy marketing request.")
        }
      } finally {
        setShowTable(true);
        setBidderEdit({isEdit: false, editRowInd:-1});
      }
    }
  };
  
  const onSaveIconClick = async (values, hand, dummyId, rowInd, row) => {
    if (!dummyId) {
      let dummy_id = new Date().getTime();
      let surveyId =
        parseInt(new Date().toISOString().replace(/[-:.TZ]/g, ""));
      let newRow = {
        dummyId: dummy_id,
        id: 0,
        surveyStatus: "Pending",
        surveyId: surveyId,
        ...values,
      };

      if (witchAction === 'update') {
         createEmpowerxBidInfoSingle(newRow);
      }
      else {
        let addData = [...bidderTableData];
        addData.splice(rowInd, 1, newRow);
        setBidderTableData([...addData]);
      }
    } else {
      if (bidderEdit.isEdit) {
        let updatedRow ={...row, ...values };
        let data = [...bidderTableData];
        data.splice(rowInd, 1, updatedRow );
        if(witchAction === 'update'){
          let isFailure = await updateEmpowerxBidInfo(updatedRow);
          if(isFailure) {
            return;
          }
        }
        setBidderTableData([...data]);
      } 
    }
    setBidderEdit({isEdit:false, editRowInd:-1})
  };

  const onBidderRowDelete =async (dummyId , rowInd, id) => {
    let data = [...bidderTableData];
    if(id > 0){
      let isFailure = await deleteEmpowerxBidInfo(id);
      if(isFailure) {
        return;
      }
    }
    if (data.length > 1) {
      if (dummyId) {
        data.splice(rowInd, 1);
      } else {
        data.splice(data.length - 1, 1);
      }
      setBidderTableData([...data]);
    } else {
      setBidderTableData([{}]);
    }
  };
  const handleChangeEmail = (event, handleChange) => {
    const { name, value } = event.target;
    handleChange({
      target: {
        name,
        value: value.trim(),
      },
    });
  };

  const downloadExisBidFileInBg = (data, filename) => {
    const csv = convertToCSV(data, columnBidder);
    const csvBlob = new Blob([csv], { type: 'text/csv' });
    const csvFile = new File([csvBlob], filename, { type: 'text/csv' });
    setExsitingBidderInfoCSV(csvFile);
  }
  const convertToCSV = (objArray, columns) => {
    let csv = '';
    const titles = columns.map(column => column.title);
    const fields = columns.map(column => column.field);
    csv += titles.join(',') + '\r\n';
    objArray?.forEach(obj => {
      const row = fields.map(field => {
        return obj[field] !== undefined ? obj[field] : '';
      });
      csv += row.join(',') + '\r\n';
    });
    return csv;
  }
  const onDownloadExistBidCsv = (filename) => {
    const csvUrl = window.URL.createObjectURL(exsitingBidderInfoCSV);
    const link = document.createElement('a');
    link.href = csvUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link?.click();
    document.body.removeChild(link);
  }
  const onSubmitHandler = async () => {
    let isFileError = false;
    let _fileErrors = {...fileErrors};

    if(!SBCFile){
      _fileErrors = {..._fileErrors, sbcFile: true, sbcFileError:"Please Upload SBC file"};
      isFileError = true;
    }
    else if(!checkFileSizelimit(SBCFile)){
      _fileErrors = {..._fileErrors, sbcFile: true, sbcFileError:"SBC File size cannot exceed 60 MB"};
      isFileError = true;
    }
    if(!exsitingBidderInfoCSV){
      _fileErrors = {..._fileErrors, rxClaimFile: true, rxClaimFileError:"Please Upload RX Claim File"};
      isFileError = true;
    }
    else if(!checkFileSizelimit(exsitingBidderInfoCSV)){
      _fileErrors = {..._fileErrors, rxClaimFile: true, rxClaimFileError:"RX Claim File size cannot exceed 60 MB"};
      isFileError = true;
    }

    const errors = await addNewQuesListFormikRef.current?.validateForm() ?? {};
    if(isFileError || (Object.keys(errors).length > 0)) {
      if (isFileError) {
        setFileErrors({ ..._fileErrors });
      }
      if (Object.keys(errors).length > 0) {
        addNewQuesListFormikRef.current.setTouched(errors);
      }
      return;
    }
   
    isSubmitDisabled.current = true;
    setShowTable(false);
    setIsLoading(true);
    try {
      let isAdditionalQuestions =  addNewQuesListFormikRef.current?.values?.needAdditionalQues ?? 'No';
      let additionalQuestionsList = "";
      let additionalQuestions = "";

      if (isAdditionalQuestions === "Yes") {
        let { questionsList, questionsJson } = sortAddNewQuesTableData(addNewQuesListFormikRef.current.values.questions, additionalQuesTableData);

        additionalQuestionsList = JSON.stringify(questionsList);
        additionalQuestions = JSON.stringify(questionsJson);

        let payload = prepareRFPPayload({
          ...mainRFPFormikRef.current?.values,
          isAdditionalQuestions: isAdditionalQuestions,
          additionalQuestionsList: additionalQuestionsList,
          additionalQuestions: additionalQuestions,
        });
        const rfpUpdateResp = await EmpowerxRfpUpdate(payload);
        if (!rfpUpdateResp?.data?.issuccess) {
          // toastFile("Failed to save additional questions");
          return;
        }
      }
      
      const res = await SubmitRfp(RFPID, exsitingBidderInfoCSV, SBCFile);
      if (res.status === 200) {
        toastFile("SubmitButton");
        setShowModal(false);
      }
    } catch (error) {
      isSubmitDisabled.current = false;
      toastFile("Failed to submit request.")
      console.log("Error:", error);
    } finally {
      setIsLoading(false);
      setShowTable(true);
    }
  };

  const onHandleDownloadFile = (FileURL) => {
    if (FileURL) {
      const FileName = FileURL.split("/").pop();
      GetPresignedURL(selectedRowData?.id, FileName).then((res) => {
        if (res.data.issuccess) {
          const link = document.createElement("a");
          link.href = res.data.data;
          link.setAttribute("download", FileName);
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);

          // Start download
          link.click();

          // Clean up and remove the link
          link.parentNode.removeChild(link);
        }
      });
      //   DownloadFile(FileURL).then((res) => {
      //   const urlParts = res.config.url.split('/');
      //   const filename = decodeURIComponent(urlParts[urlParts.length - 1]);
      //   const blob = new Blob([res.data]);
      //   const blobURL = URL.createObjectURL(blob);
      //   const link = document.createElement("a");
      //   link.href = blobURL;
      //   link.download = filename;
      //   document.body.appendChild(link);
      //   link?.click();
      //   document.body.removeChild(link);
      //   URL.revokeObjectURL(blobURL);
      // });
    }
  };

  const handleDuplicateClick = async(item)=>{
    setIsLoading(true);
    let surveyId = parseInt(new Date().toISOString().replace(/[-:.TZ]/g, ""));
    const created = new Date().toISOString();
    const enc_rfpId = CryptoJS.AES.encrypt(
      JSON.stringify(selectedRowData.id),
      process.env.REACT_APP_AES_KEY
    ).toString();
    const enc_surveyID = CryptoJS.AES.encrypt(
      JSON.stringify(surveyId),
      process.env.REACT_APP_AES_KEY
    ).toString();
    const enc_link = CryptoJS.AES.encrypt(
      JSON.stringify(`rfpid=${enc_rfpId}&surveyid=${enc_surveyID}`),
      process.env.REACT_APP_AES_KEY
    ).toString();
    const surveyLink = `${process.env.REACT_APP_API}/Questionnaire/home?r=${enc_link}`;
    
    let payload = {
      id: 0,
      rfpid: +selectedRowData.id,
      surveyID: surveyId,
      surveyLink: surveyLink,
      surveyStatus: "Sent",
      bidderCompanyName: item.bidderCompanyName,
      bidderContactName: item.bidderContactName,
      bidderContactEmail: item.bidderContactEmail,
      bidderContactPhone: item.bidderContactPhone,
      jobTitle: item.jobTitle,
      mailingAddress: item.mailingAddress,
      city: item.city,
      state: item.state,
      zip: item.zip,
      created: created,
      duplicate:true
    };
    
    try {
      const res = await CreateBidderInfo(payload);
      if (res?.status === 200) {
        let response = await DuplicateQuestionnarie(selectedRowData.id, item.surveyID,surveyId)
        if(response?.status === 200){
            toastFile(response.data.message,response.data.issuccess?"success":"error")
          getBidderListInfo(+selectedRowData.id, witchAction);
        }else{
          toastFile("Failed to duplicate Questionnarie.")
        }
      }
      else {
        toastFile("Failed to duplicate bidder info.")
        setBidderEdit((prev=>({...prev,isEdit:false})))
        // return true;
      }
    } catch (error) {
      console.log("Error:", error);
      setIsLoading(false);
   }
  }

  const handleDeleteDuplicateClick = async(item)=>{
    setIsLoading(true);
    try {
        let response = await DeleteDuplicateQuestionnaire(selectedRowData.id, item.surveyID)
        if(response?.status === 200){
          toastFile(response.data.message,response.data.issuccess?"success":"error")
          getBidderListInfo(+selectedRowData.id, witchAction);
        }else{
          toastFile("Failed to delete Questionnarie.")
        }
    } catch (error) {
      console.log("Error:", error);
    setIsLoading(false);
   }
  }

  const updateBidInfoForQuestionnaire = async (item, index) => {
    let updatedData = [...pharmMaketingQuenDetail];
    updatedData.splice(index, 1, item);

    let prevFinalistIndex = -1;
    let prevFinalist;

    if (item.finalist === 'finalist') {
      prevFinalist = [...pharmMaketingQuenDetail].find((bid, bidInd) => {
        if (bid?.bidderCompanyName === item?.bidderCompanyName && bid.finalist === 'finalist') {
          prevFinalistIndex = bidInd;
          return true;
        }
        return false;
      });
    }

    if (prevFinalistIndex > -1) {
      updatedData.splice(prevFinalistIndex, 1, { ...prevFinalist, finalist: 'nonfinalist' });
    }
    setPharmMaketingQuenDetail([...updatedData]);
  }


  const closeFinalistConfirmModal = () => {
    setShowFinalistConfirmModal(false);
  }

  const closePharmMarketQuesDetailModal = () => {
    setShowMoreModal(false);
    setSelectedRowData(null);
    setBidderTableData([{}]);
    setPharmMaketingQuenDetail([]);
    setRFPID(null);
    setCanSaveFinalist(false);
  }

  const onSaveFinalistBtnClicked = ()=> {
    let isFinalistAvailable = pharmMaketingQuenDetail.some(el=>el.finalist === 'finalist');
    if(!isFinalistAvailable) {
      toastFile("Please select the finalists, and then try again");
      return;
    }
    setShowFinalistConfirmModal(true);
  }

  const onConfirmSaveFinalists = async () => {
    closeFinalistConfirmModal();
    try {
      setIsLoading(true);
      let finalistDate = new Date().toISOString();
      let filteredQuenrList = pharmMaketingQuenDetail.filter((bid) => bid.surveyStatus !== "Declined");
      const apiCalls = filteredQuenrList.map(queDetail => {
        let payload = {
          ...queDetail, 
          rfpid: +RFPID,
          finalist: queDetail.finalist || 'nonfinalist',
          finalistDate: finalistDate
        }
        return UpdateBidderInfo(payload);
      });
      const results = await Promise.all(apiCalls);

      if (results[0]?.status === 200) {
        toastFile("Finalists were saved successfully", "success");
        closePharmMarketQuesDetailModal();
      } else {
        toastFile("Failed to save finalists.");
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const onSubmitAddNewQuestion = async (values) => {
    let { question, index } = selectedQuestion || {};
    let queList = [...addNewQuesListFormikRef.current.values.questions];
    let queListJson = [...additionalQuesTableData];
    let randomNumber = values.id > 0 ? values.id : createUniqueRandumNumber()
    let updatedValues = {
      ...values,
      id: +randomNumber,
      questionName: createUniqueQuestionName(values.questionLabel, randomNumber),
    }
    const questionJson = prepareQuestionJson(updatedValues);

    if (selectedQuestion) {
      queList.splice(index, 1, updatedValues);
      queListJson.splice(index, 1, questionJson);
    } else {
      queList.push(updatedValues);
      queListJson.push(questionJson);
    }
    await addNewQuesListFormikRef.current.setFieldValue('questions', queList);
    setAdditionalQuesTableData([...queListJson]);
    setSelectedQuestion(null);
    setShowAddQuesModal(false);

    const errors = await addNewQuesListFormikRef.current?.validateForm() ?? {};
    if (Object.keys(errors).length > 0) {
      addNewQuesListFormikRef.current.setTouched(errors);
      setIsQuestionsShorted(false);
      return;
    } else {
      sortAddNewQuesTableData(queList, queListJson);
    }
  }

  const createUniqueQuestionName = (qLabel, randomNum) => {
    let str = qLabel.replaceAll(" ", "");
    let queLabel = str.length > 50 ? str.substr(0, 50) : str;
    return queLabel + randomNum;
  }

  const createUniqueRandumNumber = () => {
    let queList = [...addNewQuesListFormikRef.current.values.questions];
      let randomNumber;
      do {
        randomNumber = Math.floor(Math.random() * 999) + 1;
      } while (queList.some((que)=> {
        let num = que.questionLabel.slice(-3);
        return (num == randomNumber || randomNumber === 0);
      }));
      return randomNumber;
  }

  const sortAddNewQuesTableData = (data, dataJson) => {
    if (!isQuestionsShorted) {
      let _sortedData = [...data].sort((a, b) => +a.questionNumber - +b.questionNumber);
      let serializedQueData = _sortedData.map((item, index) => ({
        ...item,
        questionNumber: index + 1
      }));
      addNewQuesListFormikRef.current.setFieldValue('questions', serializedQueData);

      let _sortedDataJson = [...dataJson].sort((a, b) => +a.questionsNumber - +b.questionsNumber);
      let serializedQueDataJson = _sortedDataJson.map((item, index) => ({
        ...item,
        questionsNumber: index + 1
      }));
      setAdditionalQuesTableData(serializedQueDataJson);
      setIsQuestionsShorted(true);
      return ({ questionsList: serializedQueData, questionsJson: serializedQueDataJson });
    } else {
      addNewQuesListFormikRef.current.setFieldValue('questions', data);
      setAdditionalQuesTableData(dataJson);
      setIsQuestionsShorted(true);
      return ({ questionsList: data, questionsJson: dataJson });
    }
  }

  const prepareQuestionJson = (values) => {
    let options = JSON.parse(values.questionType).type === 'dropdown' ?
      values.dropdownValues.split(',').map(string => {
        let str = string.trim();
        let obj = {};
        if(JSON.parse(values.dropdownType).type === 'multiSelectDropdown') {
          obj = {
            label: str,
            value: str,
          };
        } else {
          obj = {
            lable: str,
            value: values.dropdownValuesRequireExplanation.includes(str) ? '-1' : str,
          };
        }
        return obj;
      }) :
      undefined;

    let questionData =   {
      id: +values.questionNumber,
      page: "Additional Questions",
      section: "Additional Questions",
      questionsNumber: +values.questionNumber,
      questionLabel: values.questionLabel, 
      helpertext: values.questionHelperText,
      fields: [
        {
          name: values.questionName,
          label: values.questionLabel,
          placeholder: "",
          type:values.dropdownType && JSON.parse(values.dropdownType).type === 'multiSelectDropdown' ? 'multiSelectDropdown' : JSON.parse(values.questionType).type,
          options: options,
          required: JSON.parse(values.isQuestionRequired).value,
          disabled: false,
          isAmount: JSON.parse(values.questionType).value === 'isAmount',
          isNumber: (JSON.parse(values.questionType).value === 'number' || JSON.parse(values.questionType).value === 'isAmount' || JSON.parse(values.questionType).value === 'isPercentage'),
          isPercentage: JSON.parse(values.questionType).value === 'isPercentage',
          dispPercentStoreDecim: JSON.parse(values.questionType).value === 'isPercentage',
          value: "",
          comment: "",
          validationType: (JSON.parse(values.questionType).value === 'number' || JSON.parse(values.questionType).value === 'isAmount' || JSON.parse(values.questionType).value === 'isPercentage') ? 'number': 'string',
          validations: [
            JSON.parse(values.isQuestionRequired).value && {
              type: "required",
              params: ["This field is required"],
            },
            (JSON.parse(values.questionType).value === 'number' || JSON.parse(values.questionType).value === 'isAmount' || JSON.parse(values.questionType).value === 'isPercentage') && {
              type: "typeError",
              params: ["Please enter number"],
            },
            JSON.parse(values.questionType).value === 'isPercentage' && {
              type: "lessThan",
              params: [100, "Please enter between 0 and less than 100"],
            },
            JSON.parse(values.questionType).value === 'isPercentage' && {
              type: "moreThan",
              params: [0.009, "Please enter between 0 and less than 100"],
            },
          ].filter(Boolean),
        },
      ],
    }

    if(values.explanationRequired && JSON.parse(values.explanationRequired).value === 'Yes'){
      let explanationField = {
        name: values.questionName + "Comment" /* based on dropdown field, Note: create name value same as your dropdown name value and add Comment word on last of dropdown value */,
        placeholder: "Explanation here",
        type: "dropdownTextArea",
        validationType: "string",
        required: true,
        disabled: false,
        value: "",
        validations: [
          {
            type: "when",
            params: [
              values.questionName,
              {
                is: "-1",
                then: [
                  {
                    type: "required",
                    params: ["This field is required"],
                  },
                ],
                otherwise: [],
              },
            ],
          },
        ],
      };
      questionData.fields.push(explanationField);
    }

    return {...questionData, uniqueID: questionData.fields[0].name};
  }

  const validationSchemaAddNewQuesList = Yup.object().shape({
    needAdditionalQues: Yup.string().required('Please select option'),
    questions: Yup.array()
      .of(
        Yup.object().shape({
          questionNumber: Yup.string()
            .required('required')
            .matches(/^[0-9]+$/, 'Please enter a number')
            .test(
              'unique-questionNumber',
              'Question # already exists',
              function (value) {
                const { questions } = this.options.context;
                const currentIndex = this.options.index;
                const duplicateInForm = questions.some(
                  (q, index) => q?.questionNumber === value && index !== currentIndex
                );
                if(duplicateInForm) {
                  return this.createError({
                    path: 'questions',
                    message: 'Duplicate question numbers exist. Please change question numbers and then try again',
                    type: 'duplicate'
                  });
                }
                // return !duplicateInForm;
                return true;
              }
            ),
        })
      )
      .when('needAdditionalQues', {
        is: 'Yes',
        then: (schema) => schema.min(1, 'Please add questions and try again'),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

  const onChangeQuestionNumber = (e, index) => {
    let updatedItem = {...[...additionalQuesTableData][index],questionsNumber: e.target.value};
    let updatedData = [...additionalQuesTableData];
    updatedData.splice(index, 1, updatedItem);
    setAdditionalQuesTableData([...updatedData]);
    setIsQuestionsShorted(false);
  }

  const onDeleteNewQues = () => {
    let { index } = selectedQuestion || {};
    let queList = [...addNewQuesListFormikRef.current.values.questions];
    let queListJson = [...additionalQuesTableData];

    queList.splice(index, 1);
    queListJson.splice(index, 1);
    sortAddNewQuesTableData(queList, queListJson);
    closeQueDeleteModal();
  }

  const getAdditionalQuestionList = () => {
    if (selectedRowData.isAdditionalQuestions === "Yes") {
      let questionsJson = JSON.parse(selectedRowData.additionalQuestions);
      setAdditionalQuesTableData([...questionsJson]);
      setInitlValsAddNewQuesList({
        needAdditionalQues: 'Yes',
        questions: [...JSON.parse(selectedRowData.additionalQuestionsList)]
      });
    } else {
      setInitlValsAddNewQuesList({
        needAdditionalQues: "No",
        questions: []
      });
    }
  }

  const formikPreviewQuestions = useFormik({
    initialValues: {},
    enableReinitialize: true,
    validateOnMount: true,
  });

  const closeQueDeleteModal = () => {
    setShowDeleteNewQueModal((prev) => ({ ...prev, isShowModal: false, confirmStep: 0 }));
    setSelectedQuestion(null);
  }

  const onChangeClient = async (EmpowerxData, clientId, isUpdateModalLoading) => {
    const { setFieldValue } = mainRFPFormikRef.current || {};
    getClientData(clientId, isUpdateModalLoading);
    
    const filterData = EmpowerxData.find((el)=>el.clientId === clientId)
    if (filterData) {
      setisDisable(true);
      setEmpoweRxDiscount(filterData);
      setFieldValue('IncumbentPBM', JSON.stringify(
        pbmList.find((d) => d.Name == filterData?.pbmName)
      ));
      setFieldValue(
        "ContractTermDate",
        filterData?.currentContractTerminationDate?.split(
          "T"
        )[0]
      );
      setFieldValue("Members", filterData?.numberOfMembers);
      if (!isUpdateModalLoading && filterData?.numberOfMembers) {
        let MemberValue = filterData?.numberOfMembers
        let value = MemberValue < 5000 ? '15000' :
          (MemberValue >= 5000 && MemberValue <= 10000) ? '20000' :
            MemberValue > 10000 ? '25000' : '';
        setFieldValue("RFPCompensationFee", value);
      }
      setFieldValue(
        "Employees",
        filterData?.numberOfEmployees
      );
      setFieldValue(
        "Retail30Network",
        filterData?.retail30Network
      );
      setFieldValue(
        "Retail90Value",
        filterData?.retai90Network
      );
      setFieldValue(
        "MailPharmacyProgram",
        filterData?.mailProgram
      );
      setFieldValue(
        "SpecialtyPharmacyNetwork",
        filterData?.specialtyProgram
      );
      setFieldValue(
        "FormularyDrugListStrategy",
        filterData?.formularyStrategy
      );
      setFieldValue(
        "ClinicalPrograms",
        filterData?.clinicalPrograms
      );
      setFieldValue(
        "SpecialtyCopayCard",
        filterData?.specialtyCopayCard
      );
      setFieldValue(
        "PatientAssistanceProgram",
        filterData?.alternativeFunding
      );
      setFieldValue(
        "AccumulatorAdjustmentProgram",
        filterData?.accumulatorAdjustmentProgram
      );
      setFieldValue("OnsitePharmacyID", filterData?.onsitePharmacyID);
    } else {
      setisDisable(false);
      if (!isUpdateModalLoading) {
        setFieldValue("RFPCompensationFee", '');
        setFieldValue('IncumbentPBM', '')
        setFieldValue("ContractTermDate", "");
        setFieldValue("Members", "");
        setFieldValue("Employees", "");
        setFieldValue("Retail30Network", "");
        setFieldValue("MailPharmacyProgram", "");
        setFieldValue("SpecialtyPharmacyNetwork", "");
        setFieldValue("FormularyDrugListStrategy", "");
        setFieldValue("ClinicalPrograms", "");
        setFieldValue("SpecialtyCopayCard", "");
        setFieldValue("PatientAssistanceProgram", "");
        setFieldValue("AccumulatorAdjustmentProgram", "");
        setFieldValue("Retail90Value", "");
        setFieldValue("OnsitePharmacyID", "");
      }
    }
  }

  const onSaveFinalWinner = async (values) => {
    let payload = prepareRFPPayload({
      ...mainRFPFormikRef.current?.values,
      finalWinnerCompanyName: values.finalWinner,
    });
    setShowTable(false);
    setIsLoading(true);
    try {
      const rfpUpdateResp = await EmpowerxRfpUpdate(payload);
      if (rfpUpdateResp.status === 200) {
        toastFile("Final winner was saved", 'success');
        setShowModal(false);
      } else {
        toastFile("Failed to save final winner");
      }
    } finally {
      setIsLoading(false);
      setShowTable(true);
    }
  }

  const closeFinalWinnerModal = () => {
    setShowFinalWinnerConfirmModal(false);
    finalWinnerFormikRef.current.resetForm();
  }

  const handleValidationError = async() => {
    const errors = await mainRFPFormikRef.current?.validateForm() ?? {};
    if (Object.keys(errors).length > 0) {
      setTimeout(()=>{
        setErrorPreventingModel(true)
      },[100])
    }else{
      return;
    }
  };

  return (
    <div>
      <Modal
        show={errorPreventingModel}
        aria-labelledby="contained-modal-title-vcenter"
        className="mt-4"
      >
        <Modal.Header closeButton onHide={() => setErrorPreventingModel(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading2}
            className="text-warning"
          >
           Warning
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-nowrap text-dark">
            Please complete all required fields and then try again.
          </div>
          <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
            <button style={Fontstyling.cancelbutton} onClick={()=>setErrorPreventingModel(false)}>
            OK
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <ConfirmModal
        ifYes={onConfirmSaveFinalists}
        show={showFinalistConfirmModal}
        closeModal={closeFinalistConfirmModal}
        massage={"You selected to save finalists. Once the finalists were saved, the system will send a non-selected email to all non-finalist bidders. This action is not reversable. Do you want to proceed?"}
      />
      <Modal
        show={showMoreModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
        // size={"xl"}
        dialogClassName="modal-80w"
        scrollable
      >
        <Modal.Header
          closeButton
          onHide={closePharmMarketQuesDetailModal}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            Pharmacy Marketing Questionnaire Details
          </Modal.Title>
          {isLoading && (
            <div className="d-flex justify-content-center align-items-center absolute-loader">
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="false"
                style={{ marginRight: "5px" }}
              />
              <span>Loading...</span>
            </div>
          )}
        </Modal.Header>
        <Modal.Body className="position-relative">
          <div className="p-0 mt-1">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="thead-dark">
                  <tr className="text-center">
                    <th style={Fontstyling.label}>
                      Bidder Company Name
                    </th>
                    <th style={Fontstyling.label}>
                      Bidder Contact Name
                    </th>
                    <th style={Fontstyling.label}>
                      Bidder Email
                    </th>
                    <th style={Fontstyling.label}>
                      View Questionnaire Link
                    </th>
                    <th style={Fontstyling.label}>
                    Questionnaire Sent / Created Date
                    </th>
                    <th style={Fontstyling.label}>
                      Questionnaire  Status
                    </th>
                    <th style={Fontstyling.label}>
                      Responder
                    </th>
                    {((!canSaveFinalist && (user?.UserRole !== "Admin" || user?.UserRole !== "Pharmacy")) || (user?.UserRole === "Admin" || user?.UserRole === "Pharmacy")) && 
                      <th style={Fontstyling.label}>
                        Finalist
                      </th>
                    }
                    {!canSaveFinalist &&
                      <th style={{ ...Fontstyling.label, minWidth: 150, width: 150, maxWidth: 150 }}>
                        Finalist / Non finalist Date
                      </th>
                    }
                    {canSaveFinalist &&
                      <th style={{ ...Fontstyling.label, minWidth: 150, width: 150, maxWidth: 150 }}>
                        Actions
                      </th>
                    }
                  </tr>
                </thead>
                <tbody className="text-center">
                  {pharmMaketingQuenDetail?.map((item, index) => (
                    <tr key={index} style={Fontstyling.label}>
                      <td style={{verticalAlign:'middle'}}>{item?.bidderCompanyName}</td>
                      <td style={{verticalAlign:'middle'}}>{item?.bidderContactName}</td>
                      <td style={{verticalAlign:'middle'}}>{item?.bidderContactEmail}</td>
                      <td className="text-primary" >
                        <a style={{
                          textDecoration: "none",
                          display: "block",
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          wordBreak: "break-all",
                          cursor:"pointer"
                        }} href={item?.duplicate ? item?.surveyLink : item?.surveyLink + '&isEdit=false'} target="_blank">
                           {item?.surveyLink ? item?.surveyLink.split("?")[0] : ''}
                        </a>
                      </td>
                      <td style={{verticalAlign:'middle'}}>{item?.created && moment(item?.created).format("MM/DD/YYYY")}</td>
                      <td style={{verticalAlign:'middle'}}>
                        {(() => {
                          let badgeColor;
                          switch (item?.surveyStatus) {
                            case "Sent":
                              badgeColor = "success";
                              break;
                            case "Submitted":
                              badgeColor = "primary";
                              break;
                            case "Declined":
                              badgeColor = "dark";
                              break;
                          }
                          return (
                            <Badge
                              pill
                              className="fw-normal py-1 px-3"
                              bg={badgeColor}
                              style={{ fontSize: "10px" }}
                            >
                              {item?.surveyStatus ?  item?.surveyStatus : ""}
                            </Badge>
                          );
                        })()}
                      </td>
                      <td style={{verticalAlign:'middle'}}>{item?.respondentName}</td>
                      {((!canSaveFinalist && (user?.UserRole !== "Admin" || user?.UserRole !== "Pharmacy")) || (user?.UserRole === "Admin" || user?.UserRole === "Pharmacy")) &&
                        <td style={{ verticalAlign: 'middle' }}>
                          {(item.surveyStatus !== 'Declined') && (<Form.Check
                            id={`checkbox-finalist-${index}`}
                            className="mb-0 fs-6"
                            style={{ minHeight: 0 }}
                            type="checkbox"
                            onChange={(e) => {
                              let checked = e.target.checked;
                              updateBidInfoForQuestionnaire({ ...item, finalist: checked ? 'finalist' : 'nonfinalist' }, index);
                            }}
                            checked={item?.finalist === 'finalist'}
                            disabled={!canSaveFinalist}
                          />)}
                        </td>
                      }
                      {!canSaveFinalist && <td style={{ verticalAlign: 'middle' }}>{item?.finalistDate && moment(item.finalistDate).format("MM/DD/YYYY") !== "01/01/0001" && item && moment(item.finalistDate).format("MM/DD/YYYY")}</td>}
                      {canSaveFinalist && <td style={{ verticalAlign: 'middle' }}>
                        <div className="d-flex align-items-center justify-content-center gap-1">
                          <>
                            {item?.surveyStatus === "Submitted" &&
                              <>
                                {!item?.duplicate &&
                                  <OverlayTrigger
                                    placement={"bottom"}
                                    trigger={["hover", "focus"]}
                                    overlay={
                                      <Tooltip>Duplicate</Tooltip>
                                    }
                                  >
                                    <Button
                                      className="btn-light rounded-circle icon-container p-0"
                                      onClick={() => handleDuplicateClick(item)}
                                    >
                                      <FaRegClone />
                                    </Button>
                                  </OverlayTrigger>
                                }
                              </>
                            }
                            <>
                              {item?.duplicate &&
                                <Button
                                  className="btn-light rounded-circle icon-container p-0"
                                  onClick={() => handleDeleteDuplicateClick(item)}
                                >
                                  <FaTrash />
                                </Button>
                              }
                            </>
                          </>
                        </div>
                      </td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {(user?.UserRole === "Admin" || user?.UserRole === "Pharmacy") && canSaveFinalist && <Button
            style={Fontstyling.savebutton}
            onClick={onSaveFinalistBtnClicked}
            disabled={isLoading}
          >
            Save Finalist
          </Button>}
          <Button
            style={Fontstyling.cancelbutton}
            onClick={closePharmMarketQuesDetailModal}
            disabled={isLoading}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {showModal && <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
        size={witchAction !== "delete" ? "xl" : "md"}
        className={`${(showAddQuesModal || showQuePreviewModal) ? 'd-none' : ''}`}
      >
        <Modal.Header
          closeButton
          onHide={() => {
            setShowModal(false);
            setisDisable(false)
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
                ? "Update "
                : witchAction === "delete" ? "Delete " : " "}
            Pharmacy Marketing Request 
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: witchAction !== "delete" ? "80vh" : "", overflowY: witchAction !== "delete" ? "scroll" : "" }}>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                setShowTable(false);
                EmpowerxRfpDelete(selectedRowData?.id)
                  .then((res) => {
                    if (res.status === 200 || res.status === 204) {
                      toastFile("delete");
                      setShowModal(false);
                    }
                  })
                  .finally((res) => setShowTable(true));
              }}
              onClickNo={() => setShowModal(false)}
              />
          ) : (
          <Formik
            enableReinitialize
            innerRef={mainRFPFormikRef}
            validationSchema={schema}
            onSubmit={(values , { setSubmitting }) => {
              handleActions(values);
              // setSubmitting(false); 
            }}
            
            initialValues={{
              pharmacyMarketing: selectedRowData ? selectedRowData?.pharmacyMarketingOption : '',
              RFPReleaseDate: selectedRowData
              ? selectedRowData?.releaseDate?.split("T")[0]
              : "",
              RFPTitle: selectedRowData ? selectedRowData?.title : "",
              client: selectedRowData ? {
                value: selectedRowData?.clientId,
                label: selectedRowData?.clientName,
              }
                : null,
              IncumbentPBM: selectedRowData?.incumbentPBM
                ? JSON.stringify(
                  pbmList.find((d) => d.Name == selectedRowData.incumbentPBM)
                )
                : "",
              RFPDueDate: selectedRowData
                ? selectedRowData?.dueDate?.split("T")[0]
                : "",
              RFPReviewDate: selectedRowData
                ? selectedRowData?.reviewDate?.split("T")[0]
                : "",
              QADate: selectedRowData
                ? selectedRowData?.qaDate?.split("T")[0]
                : "",
              PrimaryContactInfo: selectedRowData
                ? selectedRowData?.primaryContactInfo
                : "",
              PrimaryContactEmail: selectedRowData
                ? selectedRowData?.primaryContactEmail
                : "",
              PrimaryContactPhone: selectedRowData
                ? selectedRowData?.primaryContactPhone
                : "",
              SecondaryContactEmails: selectedRowData
                ? selectedRowData?.secondaryContactEmail
                : "",
              GoalsforRFP: selectedRowData ? selectedRowData?.rfpGoal : "",
              ToleranceforChange: selectedRowData
                ? selectedRowData?.toleranceForChange
                : "",
              VendorScope: selectedRowData ? selectedRowData?.vendorScope : "",
              ContractTermDate: selectedRowData
                ? selectedRowData?.contractTermDate?.split("T")[0]
                : "",
              IncumbentMedicalCarrierTPA: selectedRowData
                ? selectedRowData?.incumbentMedicalCarrier
                : "",
              EstimatedTotalSpendperYear: selectedRowData
                ? selectedRowData?.estimatedTotalSpendperYear
                : "0",
              RxClaimsBeginningDate: selectedRowData
                ? selectedRowData?.rxClaimsBeginningDate.split("T")[0]
                : "",
              RxClaimsEndingDate: selectedRowData
                ? selectedRowData?.rxClaimsEndingDate.split("T")[0]
                : "",
              Members: selectedRowData ? selectedRowData?.noofMembers : "",
              RFPCompensationFee: selectedRowData?.rfpCompensationFee  ? selectedRowData?.rfpCompensationFee 
              : (() => {
                  let MemberValue = selectedRowData?.noofMembers;
                  return MemberValue < 5000
                    ? '15000'
                    : MemberValue >= 5000 && MemberValue <= 10000
                    ? '20000'
                    : MemberValue > 10000
                    ? '25000'
                    : '';
                })() ,
              Employees: selectedRowData ? selectedRowData?.noofEmployees : "",
              MembershipDeductible: selectedRowData
                ? selectedRowData?.membershipPercentHighDeductibleHealthPlan
                : "",
              PharmacyClaims: selectedRowData
                ? selectedRowData?.pharmacyClaimPaidPercentageHighDeductHealthPlan
                : "",
              Retail30Network: selectedRowData
                ? selectedRowData?.retail30Network
                : "",
              Retail90Value: selectedRowData?.retail90
                ? selectedRowData?.retail90
                : "",
              MailPharmacyProgram: selectedRowData
                ? selectedRowData?.mailPharmacyProgram
                : "",
              SpecialtyPharmacyNetwork: selectedRowData
                ? selectedRowData?.specialtyPharmacyNetwork
                : "",
              FormularyDrugListStrategy: selectedRowData
                ? selectedRowData?.formularyDrugListStrategy
                : "",
              ClinicalPrograms: selectedRowData
                ? selectedRowData?.clinicalPrograms
                : "",
              SpecialtyCopayCard: selectedRowData
                ? selectedRowData?.specialtyCopayCard
                : "",
              PatientAssistanceProgram: selectedRowData
                ? selectedRowData?.patientAssistanceProgram
                : "",
              AccumulatorAdjustmentProgram: selectedRowData
                ? selectedRowData?.accumulatorAdjustmentProgram
                : "",
              OnsitePharmacyID : selectedRowData
                ?selectedRowData?.onsitePharmacyID
                :"",
              SBCFormFile: selectedRowData
                ? selectedRowData?.sbcFile
                : "",
              EmpowerxBidFile:selectedRowData
              ? selectedRowData?.rxClaimDataFile:"",
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                setFieldValue,
                values,
                touched,
                isValid,
                errors,
                resetForm
              }) => {
                const handleFormSubmit = async (e) => {
                  await handleSubmit(e);
                  if (Object.keys(errors).length > 0) {
                    const firstErrorField = Object.keys(errors)[0];
                    const errorFieldElement = document.getElementsByName(firstErrorField)[0];
                    if (errorFieldElement) {
                      errorFieldElement.focus();
                    }
                  }
                };
                return (
                  <Form onSubmit={handleFormSubmit}  style={witchAction === "showMoreRFP" ? { pointerEvents: "none" } : {}}>
                   <div style={isSaveDisabled.current? {pointerEvents:'none'}:{}}>
                    <p style={Fontstyling.heading} className="">
                      General Information{" "}
                    </p>
                    <Row className="w-25 gap-3">
                      <Col>
                        <Form.Group>
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Pharmacy Marketing Option<Required />
                          </Form.Label>
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="pharmacyMarketing"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.pharmacyMarketing}
                            disabled={witchAction === "showMoreRFP"}
                            isInvalid={errors.pharmacyMarketing && touched.pharmacyMarketing}
                          >
                            <option value={''}>Select Pharmacy Marketing</option>
                            {['Request for Proposal', 'Request for Renewal', 'Market Check'].map((item, index) => (
                              <option
                                key={index}
                                value={item}
                              >
                                {item}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.pharmacyMarketing}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      
                    </Row>
                    <Row className="mb-2 gap-3">
                      <Col>
                        <CustomInputField
                          label="Title"
                          name="RFPTitle"
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                          disabled={witchAction === "showMoreRFP"}
                          maxLength={100}
                        />
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Client Name
                            <Required />
                          </Form.Label>
                          <ReactSelect
                        name="client"
                        
                        className="rounded-0"
                        options={clientList}
                        value={values.client}
                        onChange={(selectedOption) => {
                          let event = {
                            target: {
                              name: "client",
                              value: selectedOption,
                            },
                          };
                          handleChange(event);
                          onChangeClient(empowrxDiscounts, selectedOption.value);
                        }}
                        onBlur={handleBlur}
                        styles={{
                          ...clientListDrpDwnStyles,
                          control: (base) => ({
                            ...clientListDrpDwnStyles.control(base),
                            border: `1px solid ${
                              errors.client && touched.client
                                ? "red"
                                : "lightgrey"
                            }`,
                            background: witchAction === "showMoreRFP" ? "#e9ecef" : "",
                            color: "black",
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            ...Fontstyling.label,
                            color: "black",
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: "black",
                          }),
                        }}
                      placeholder="Select Client Name"
                      />
                         
                          {errors.client && touched.client && (
                            <Form.Label style={Fontstyling.errorlabel}>
                              {errors.client}
                            </Form.Label>
                          )}
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Incumbent PBM
                            <Required />
                          </Form.Label>
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="IncumbentPBM"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={isDisable||witchAction === "showMoreRFP"}
                            isInvalid={
                              values.IncumbentPBM === "" &&
                              errors.IncumbentPBM &&
                              touched.IncumbentPBM
                            }
                            value={values.IncumbentPBM}
                          >
                            <option value={""}>Select Incumbent PBM</option>
                            {pbmList?.map((item, index) => (
                              <option value={JSON.stringify(item)}>
                                {item.Name}
                              </option>
                            ))}
                          </Form.Select>
                          {errors.IncumbentPBM && touched.IncumbentPBM && (
                            <Form.Label style={Fontstyling.errorlabel}>
                              {errors.IncumbentPBM}
                            </Form.Label>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3">
                    <Col>
                        <Form.Group
                          controlId="validationFormik02"
                        // className="px-2"
                        >
                          <Form.Label style={Fontstyling.label}>
                            Release Date
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1 "
                            style={{
                              ...Fontstyling.label,
                              textTransform: "uppercase",
                            }}
                            type="date"
                            name="RFPReleaseDate"
                            value={values.RFPReleaseDate}
                            disabled={witchAction === "showMoreRFP"}
                            min={formattedDate}
                            onChange={async(e)=>{
                              handleChange(e)
                              isValidDate(e.target.value) && await getHoliday(e.target.value)
                              let dueDate=addBusinessDays(e.target.value,3,holidays)
                              let reviewDate=addBusinessDays(e.target.value,8,holidays)
                              let qaDate=addBusinessDays(e.target.value,11,holidays)
                              setFieldValue('RFPDueDate',dueDate.format('yyyy-MM-DD'))
                              setFieldValue('RFPReviewDate',reviewDate.format('yyyy-MM-DD'))
                              setFieldValue('QADate',qaDate.format('yyyy-MM-DD'))
                            }}
                            onBlur={handleBlur}
                            isInvalid={errors.RFPReleaseDate && touched.RFPReleaseDate}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.RFPReleaseDate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="validationFormik02"
                        // className="px-2"
                        >
                          <Form.Label style={Fontstyling.label}>
                            Intent to Bid
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1 "
                            style={{
                              ...Fontstyling.label,
                              textTransform: "uppercase",
                            }}
                            type="date"
                            name="RFPDueDate"
                            value={values.RFPDueDate}
                            disabled={true}
                            min={formattedDate}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={errors.RFPDueDate && touched.RFPDueDate}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.RFPDueDate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="validationFormik02"
                        // className="px-2"
                        >
                          <Form.Label style={Fontstyling.label}>
                            Questions Due to HUB
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1 "
                            style={{
                              ...Fontstyling.label,
                              textTransform: "uppercase",
                            }}
                            type="date"
                            name="RFPReviewDate"
                            value={values.RFPReviewDate}
                            // disabled={witchAction === "showMoreRFP"}
                            disabled={true}
                            min={formattedDate}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.RFPReviewDate && touched.RFPReviewDate
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.RFPReviewDate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="validationFormik02"
                        // className="px-2"
                        >
                          <Form.Label style={Fontstyling.label}>
                            Responses Due back to Vendors
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1 "
                            style={{
                              ...Fontstyling.label,
                              textTransform: "uppercase",
                            }}
                            type="date"
                            name="QADate"
                            // disabled={witchAction === "showMoreRFP"}
                            disabled={true}
                            value={values.QADate}
                            min={formattedDate}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={errors.QADate && touched.QADate}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.QADate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3">
                      <Col>
                        <CustomInputField
                          label="Primary Contact Info"
                          name="PrimaryContactInfo"
                          value={values}
                          handleChange={(e) => {
                            handleChange(e);
                          }}
                          disabled={witchAction === "showMoreRFP"}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                          maxLength={100}
                        />
                      </Col>
                      <Col>
                        <CustomInputField
                          label="Primary Contact Emails (add multiple Email with semicolon ( ; ) separation)"
                          name="PrimaryContactEmail"
                          placeholder="Enter Primary Contact Emails"
                          value={values}
                          handleChange={(event) =>
                            handleChangeEmail(event, handleChange)
                          }
                          handleBlur={handleBlur}
                          disabled={witchAction === "showMoreRFP"}
                          touched={touched}
                          errors={errors}
                          isRequired
                        />
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3">
                      <Col>
                        <CustomInputField
                          label="Primary Contact Phone"
                          name="PrimaryContactPhone"
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          disabled={witchAction === "showMoreRFP"}
                          errors={errors}
                          isRequired
                          maxLength={100}
                        />
                      </Col>
                      <Col>
                        <CustomInputField
                          label="Secondary Contact Emails (add multiple Email with semicolon ( ; ) separation)"
                          name="SecondaryContactEmails"
                          placeholder="Enter Secondary Contact Emails"
                          value={values}
                          handleChange={(event) =>
                            handleChangeEmail(event, handleChange)
                          }
                          handleBlur={handleBlur}
                          disabled={witchAction === "showMoreRFP"}
                          touched={touched}
                          errors={errors}
                        // isRequired
                        />
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3">
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Goal of RFP
                            <Required />
                          </Form.Label>
                          <img
                            data-tip="Financial, administrative, etc"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="GoalsforRFP"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.GoalsforRFP}
                            disabled={witchAction === "showMoreRFP"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.GoalsforRFP && errors.GoalsforRFP}
                            placeholder="Goals for RFP"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.GoalsforRFP}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Tolerance of Change
                            <Required />
                          </Form.Label>
                          <img
                            data-tip="Formulary, vendor change, plan differences, disruptions, etc."
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="ToleranceforChange"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.ToleranceforChange}
                            disabled={witchAction === "showMoreRFP"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.ToleranceforChange &&
                              errors.ToleranceforChange
                            }
                            placeholder="Tolerance for Change"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.ToleranceforChange}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Vendor Scope
                            <Required />
                          </Form.Label>
                          <img
                            data-tip="List any hard requirements or any specific vendors to include/exclude"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="VendorScope"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            disabled={witchAction === "showMoreRFP"}
                            value={values.VendorScope}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.VendorScope && errors.VendorScope}
                            placeholder="Vendor Scope"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.VendorScope}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3">
                      <Col>
                        <Form.Group
                          controlId="validationFormik02"
                        // className="px-2"
                        >
                          <Form.Label style={Fontstyling.label}>
                            Contract Term Date
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1 "
                            style={{
                              ...Fontstyling.label,
                              textTransform: "uppercase",
                            }}
                            type="date"
                            name="ContractTermDate"
                            value={values.ContractTermDate}
                            disabled={isDisable  || witchAction === "showMoreRFP"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.ContractTermDate && touched.ContractTermDate
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {isDisable ? " " : errors.ContractTermDate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <CustomInputField
                          label="Incumbent Medical Carrier / TPA"
                          name="IncumbentMedicalCarrierTPA"
                          placeholder={"Incumbent Medical Carrier / TPA"}
                          value={values}
                          handleChange={handleChange}
                          disabled={medCarrTPADisabled ||witchAction === "showMoreRFP"}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired={true}
                          maxLength={100}
                        />
                      </Col>
                      <Col>
                        <CustomInputField
                          label="Estimated Total Spend per Year"
                          name="EstimatedTotalSpendperYear"
                          placeholder={"Estimated Total Spend per Year"}
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          disabled={witchAction === "showMoreRFP"}
                          touched={touched}
                          errors={errors}
                          isAmount={true}
                          maxLength={20}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3">
                      <Col>
                        <Form.Group
                          controlId="validationFormik02"
                        // className="px-2"
                        >
                          <Form.Label style={Fontstyling.label}>
                            Rx Claims Beginning Date
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1"
                            style={{
                              ...Fontstyling.label,
                              textTransform: "uppercase",
                            }}
                            type="date"
                            name="RxClaimsBeginningDate"
                            value={values.RxClaimsBeginningDate}
                            disabled={witchAction === "showMoreRFP"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.RxClaimsBeginningDate &&
                              touched.RxClaimsBeginningDate
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.RxClaimsBeginningDate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="validationFormik02"
                        // className="px-2"
                        >
                          <Form.Label style={Fontstyling.label}>
                            Rx Claims Ending Date
                            <Required />
                          </Form.Label>
                          <Form.Control
                            className="rounded-0 py-1"
                            style={{
                              ...Fontstyling.label,
                              textTransform: "uppercase",
                            }}
                            type="date"
                            name="RxClaimsEndingDate"
                            value={values.RxClaimsEndingDate}
                            min={values.RxClaimsBeginningDate}
                            disabled={!values.RxClaimsBeginningDate || witchAction === "showMoreRFP"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              errors.RxClaimsEndingDate &&
                              touched.RxClaimsEndingDate
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.RxClaimsEndingDate}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3">
                      <Col>
                        <CustomInputField
                          label="# of Members"
                          name="Members"
                          value={values}
                          disabled={isDisable || witchAction === "showMoreRFP"}
                          handleChange={(e) => {
                            handleChange(e);
                            let value = e.target.value < 5000 ? '15000' :
                                        (e.target.value >= 5000 && e.target.value <= 10000) ? '20000' :
                                        e.target.value > 10000 ? '25000' : '';
                              setFieldValue("RFPCompensationFee", e.target.value ? value : '');
                          }}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                          maxLength={20}
                        />
                      </Col>
                      <Col>
                        <CustomInputField
                          label="RFP Compensation Fee"
                          name="RFPCompensationFee"
                          value={values}
                          disabled={witchAction === "showMoreRFP"}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                          maxLength={20}
                          isAmount
                        />
                      </Col>
                      <Col>
                        <CustomInputField
                          label="# of Employees"
                          name="Employees"
                          value={values }
                          disabled={isDisable || witchAction === "showMoreRFP"}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                          maxLength={20}
                        />
                      </Col>
                      <Col>
                        <CustomInputField
                          label="% of Membership in High Deductible Health Plan"
                          name="MembershipDeductible"
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          disabled={witchAction === "showMoreRFP"}
                          errors={errors}
                          isRequired
                          maxLength={20}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3 col-8">
                      <Col>
                        <CustomInputField
                          label="% of Pharmacy Claims Paid in High Deductible Health Plan"
                          name="PharmacyClaims"
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          disabled={witchAction === "showMoreRFP"}
                          touched={touched}
                          errors={errors}
                          isRequired
                          maxLength={20}
                        />
                      </Col>
                      <Col>
                      <Form.Group className="text-start">
                        <Form.Label
                          className="text-nowrap"
                          style={Fontstyling.label}
                        >
                          Onsite Pharmacy ID
                        </Form.Label>
                        <img
                          data-tip="List all Onsite Pharmacy IDs, separated by comma"
                          src={require("../../../assets/icon/Question_mark_back.png")}
                          style={{ height: 15, marginLeft: 3 }}
                        />
                        <ReactTooltip
                          className="border-2 border-info p-3"
                          border
                          backgroundColor="white"
                          textColor="black"
                        />
                        <Form.Control
                          name="OnsitePharmacyID"
                          type="text"
                          disabled
                          className="py-1 rounded-0"
                          style={Fontstyling.label}
                          value={values.OnsitePharmacyID}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.OnsitePharmacyID && errors.OnsitePharmacyID}
                          placeholder="Onsite Pharmacy ID"
                          maxLength={500}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.OnsitePharmacyID}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    </Row>
                    <p style={Fontstyling.heading} className="my-3">
                      Current Plan Design Information{" "}
                    </p>
                    <Row className="mb-2 gap-3 ">
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Retail 30 Network
                            <Required />
                          </Form.Label>
                          <img
                           data-for="Retail30Network"
                            data-tip="Broad network of ~65k pharmacies | 
                          Limited network with less than ~65k pharmacies | Narrow network with less than ~40k pharmacies.  Broad networks do not exclude any major chains, Limited networks typically exclude 1 major chain and some independents, and Narrow networks exclude multiple major chains and independents"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3,}}
                          />
                          <ReactTooltip
                           id="Retail30Network"
                            className="border-2 border-info p-3 w-50"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Form.Control
                            name="Retail30Network"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.Retail30Network}
                            onChange={handleChange}
                            disabled={isDisable || witchAction === "showMoreRFP"}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.Retail30Network && errors.Retail30Network
                            }
                            placeholder="Retail 30 Network"
                            maxLength={100}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.Retail30Network}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group>
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Retail 90 Network
                          </Form.Label>
                          <img
                            data-tip="Retail 90 networks are either a proportional subset of Retail 30 or marketed as a Mail at Retail Program.  Please input Yes or No if a Retail 90 retail network is in place"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Form.Control
                            name="Retail90Value"
                            type="text"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.Retail90Value}
                            onChange={handleChange}
                            disabled={isDisable || witchAction === "showMoreRFP"}
                            onBlur={handleBlur}
                            // isInvalid={
                            //   touched.Retail90Value &&
                            //   errors.Retail90Value
                            // }
                            placeholder="Retail 90 Network"
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Mail Pharmacy Program
                            <Required />
                          </Form.Label>
                          <img
                            data-tip="Example inputs include Voluntary Mail, Incentivized Mail, Mandatory Mail, Voluntary Mail at Retail, Incentivized Mail at Retail, Mandatory Mail at Retail"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Form.Control
                            name="MailPharmacyProgram"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.MailPharmacyProgram}
                            onChange={handleChange}
                            disabled={isDisable || witchAction === "showMoreRFP"}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.MailPharmacyProgram &&
                              errors.MailPharmacyProgram
                            }
                            placeholder="Mail Pharmacy Program"
                            maxLength={100}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.MailPharmacyProgram}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3 ">
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Specialty Pharmacy Network
                            <Required />
                          </Form.Label>
                          <img
                            data-tip=" Exclusive (required to use the PBM specialty pharmacy) or Open (not required to use the PBM specialty pharmacy"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Form.Control
                            name="SpecialtyPharmacyNetwork"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.SpecialtyPharmacyNetwork}
                            onChange={handleChange}
                            disabled={isDisable || witchAction === "showMoreRFP"}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.SpecialtyPharmacyNetwork &&
                              errors.SpecialtyPharmacyNetwork
                            }
                            placeholder="Specialty Pharmacy Network"
                            maxLength={100}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.SpecialtyPharmacyNetwork}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Formulary Drug List Strategy
                            <Required />
                          </Form.Label>
                          <img
                            data-tip="Standard Formulary with exclusions, Standard Formulary without exclusions, Non-standard Formulary with exclusions, and Non-Standard Formulary without exclusions"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Form.Control
                            name="FormularyDrugListStrategy"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.FormularyDrugListStrategy}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={isDisable || witchAction === "showMoreRFP"}
                            isInvalid={
                              touched.FormularyDrugListStrategy &&
                              errors.FormularyDrugListStrategy
                            }
                            placeholder="Formulary Drug List Strategy"
                            maxLength={100}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.FormularyDrugListStrategy}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Clinical Programs
                            <Required />
                          </Form.Label>
                          <img
                            data-tip="Prior Authorization, Quantity Limits, Generic Step Therapy, Specialty Step Therapy, Adherence, Fraud Waste & Abuse programs"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Form.Control
                            name="ClinicalPrograms"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.ClinicalPrograms}
                            disabled={isDisable || witchAction === "showMoreRFP"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.ClinicalPrograms && errors.ClinicalPrograms
                            }
                            placeholder="Clinical Programs"
                            maxLength={100}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.ClinicalPrograms}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-2 gap-3 ">
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Specialty Copay Card
                          </Form.Label>
                          <img
                            data-tip="SaveOn SP, Prudent Rx, other copay card program"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Form.Control
                            name="SpecialtyCopayCard"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.SpecialtyCopayCard}
                            disabled={isDisable || witchAction === "showMoreRFP"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Specialty Copay Card"
                            maxLength={100}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Patient Assistance Program
                          </Form.Label>
                          <img
                            data-tip="Patient assistance programs like PayerMatrix or ShaRx"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                          <Form.Control
                            name="PatientAssistanceProgram"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.PatientAssistanceProgram}
                            disabled={isDisable || witchAction === "showMoreRFP"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Patient Assistance Program"
                            maxLength={100}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="text-start">
                          <Form.Label
                            className="text-nowrap"
                            style={Fontstyling.label}
                          >
                            Accumulator Adjustment Program
                            <Required />
                          </Form.Label>
                          <Form.Control
                            name="AccumulatorAdjustmentProgram"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.AccumulatorAdjustmentProgram}
                            disabled={isDisable || witchAction === "showMoreRFP"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Accumulator Adjustment Program"
                            maxLength={100}
                            isInvalid={
                              touched.AccumulatorAdjustmentProgram && errors.AccumulatorAdjustmentProgram
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.AccumulatorAdjustmentProgram}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    </div>
                    <p style={Fontstyling.heading} className="my-3">
                      Bidder Information Detail
                    </p>

                    <Table bordered hover responsive >
                      <thead style={Fontstyling.label}>
                        <tr className="text-center align-middle">
                          {[
                           { title: "Bidder Company Name", isRequired:true},
                           { title:"Bidder Contact Name", isRequired:true},
                           { title: "Bidder Contact Email", isRequired:true},
                           { title:"Bidder Contact Phone", isRequired:true},
                           { title:"Job Title", isRequired:true},
                           { title: "Mailing Address", isRequired:false},
                           { title: "City", isRequired:false},
                           { title: "State", isRequired:false},
                           { title:"Zip", isRequired:false},
                           { title:"Actions", isRequired:false},
                          ].map((el, ind) => {
                            return (
                              <th key={ind}>
                                {el.title}
                                {el.isRequired && <Required />}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {bidderTableData?.map((row, rowInd) => (
                          <BidderInfoTableRow
                            key={rowInd}
                            row={row}
                            rowInd={rowInd}
                            bidderTableData={bidderTableData}
                            setBidderTableData={setBidderTableData}
                            onRowDelete={onBidderRowDelete}
                            onSaveIconClick={onSaveIconClick}
                            inpRef={inpRef}
                            formikRef={formikRef}
                            witchAction={witchAction}
                            stateList={stateList}
                            bidderEdit={bidderEdit}
                            setBidderEdit={setBidderEdit}
                            isSaveDisabled={isSaveDisabled}
                          />
                        ))}
                      </tbody>
                    </Table>
                    {isSaveDisabled.current && (
                      <p className="text-primary text-end">Data saved successfully.</p>
                    )}

                  {witchAction === 'showMoreRFP' &&
                      <Formik
                        innerRef={finalWinnerFormikRef}
                        enableReinitialize
                        validationSchema={
                          Yup.object().shape({
                            finalWinner: Yup.string().trim().required('Please select a final winner, and then try again'),
                          })
                        }
                        initialValues={{
                          finalWinner: selectedRowData?.finalWinnerCompanyName ?? ""
                        }}
                        onSubmit={onSaveFinalWinner}
                      >
                        {({
                          handleSubmit,
                          handleChange,
                          handleBlur,
                          setFieldValue,
                          values,
                          touched,
                          isValid,
                          errors,
                          resetForm,
                          validateForm,
                          setTouched
                        }) => (
                          <Form id="final-winner">
                            <Row className="align-items-center gap-3 my-3" style={{ pointerEvents: 'initial' }}>
                              <Col className="col-4">
                                <Form.Group className="text-start row align-items-center gap-3">
                                  <Form.Label
                                    className="text-nowrap col-auto mb-0"
                                    style={Fontstyling.label}
                                  >
                                    Final Winner
                                    <Required />
                                  </Form.Label>
                                  <Col>
                                    <Form.Select
                                      className="py-1 rounded-0"
                                      style={Fontstyling.label}
                                      name="finalWinner"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      isInvalid={
                                        errors.finalWinner &&
                                        touched.finalWinner
                                      }
                                      value={values.finalWinner}
                                      disabled={selectedRowData?.finalWinnerCompanyName || isLoading}  
                                      >
                                      <option value={""}>Select</option>
                                      {uniqueBidCompanies?.map((comp) => <option value={comp}>{comp}</option>)}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.finalWinner}
                                    </Form.Control.Feedback>
                                  </Col>
                                </Form.Group>
                              </Col>

                              <button
                                className="col-auto"
                                style={{ ...Fontstyling.savebutton, textTransform: 'initial', opacity: (selectedRowData?.finalWinnerCompanyName || isLoading) ? 0.5 : 1 }}
                                type="button"
                                onClick={async()=>{
                                  let errors = await validateForm();
                                  if(Object.keys(errors).length > 0) {
                                    setTouched(errors);
                                    return;
                                  }
                                  setShowFinalWinnerConfirmModal(true);
                                }}
                                disabled={selectedRowData?.finalWinnerCompanyName || isLoading}  
                              >
                                Save final winner
                              </button>
                            </Row>
                          </Form>
                        )}
                      </Formik>
                    }

                    {(witchAction === 'showMoreRFP' || isSaveDisabled.current
                    ) && (
                        <>
                          <Row className="w-50" style={witchAction === "showMoreRFP" ? { pointerEvents: "auto", justifyContent: "space-between" } : {}}>
                            <Col>
                              <Form.Group>
                                <Form.Label className="text-nowrap" style={Fontstyling.label}>
                                  SBC file upload Area<Required />
                                </Form.Label>
                              {witchAction === "showMoreRFP" ? <div style={Fontstyling.label}>
                                <span
                                  className="text-primary"
                                  style={values.SBCFormFile ? { cursor: "pointer" } : {}}
                                  onClick={() => onHandleDownloadFile(values.SBCFormFile)}>
                                  {values.SBCFormFile ? values.SBCFormFile.split('/').pop() : 'No file uploaded'}
                                </span>
                              </div> : <Form.Control
                                type="file"
                                accept=".csv, .docx, .doc, .xlxs, .xls, .txt, .pdf, .rtx, .zip, .rar"
                                className="py-1 rounded-0"
                                style={{...Fontstyling.label, ...fileErrors.sbcFile && { borderColor: "#DC3545" }} }
                                name="SBCFormFile"
                                onChange={(event) => {
                                  setSBCFile(event.target.files[0]);
                                  const file = event.currentTarget.files[0];
                                  setFieldValue("SBCFormFile", file);
                                setFileErrors(prev=>({...prev, sbcFile: false, sbcFileError:null}));
                                }}
                                onBlur={handleBlur}
                                isInvalid={errors.SBCFormFile && touched.SBCFormFile}
                              ></Form.Control>}
                                 {fileErrors.sbcFile && <div className="mt-2" style={Fontstyling.errorlabel}>
                                  {fileErrors.sbcFileError}
                                </div>}
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row className="w-50 mt-3" style={witchAction === "showMoreRFP" ? { pointerEvents: "auto", justifyContent: "space-between" } : {}}>
                            <Col className="">
                              <Form.Group>
                                <Form.Label
                                  className="text-nowrap"
                                  style={Fontstyling.label}
                                >
                                  Rx Claim Data upload Area<Required />
                                </Form.Label>
                              {witchAction === "showMoreRFP" ?
                                <div style={Fontstyling.label}>
                                  <span
                                    className="text-primary"
                                    style={values.EmpowerxBidFile ? { cursor: "pointer" } : {}}
                                    onClick={() => onHandleDownloadFile(values.EmpowerxBidFile)}>
                                    {values.EmpowerxBidFile ? values.EmpowerxBidFile.split('/').pop() : 'No file uploaded'}
                                  </span>
                                </div> : !isExistingBidRes ? <Form.Control
                                  type="file"
                                  accept=".csv, .xls, .xlsx"
                                  className="py-1 rounded-0"
                                  style={{...Fontstyling.label, ...fileErrors.rxClaimFile && { borderColor: "#DC3545" }} }
                                  placeholder="Select File"
                                  name="EmpowerxBidFile"
                                  onBlur={handleBlur}
                                  onChange={(event) => {
                                    setExsitingBidderInfoCSV(event.target.files[0]);
                                    const file = event.currentTarget.files[0];
                                    setFieldValue("EmpowerxBidFile", file);
                                    setFileErrors(prev=>({...prev, rxClaimFile: false,rxClaimFileError:null}));
                                  }}
                                  isInvalid={
                                    errors.EmpowerxBidFile &&
                                    touched.EmpowerxBidFile
                                  }
                                ></Form.Control> : null
                              }
                               {fileErrors.rxClaimFile && <div className="mt-2" style={Fontstyling.errorlabel}>
                                  {fileErrors.rxClaimFileError}
                                </div>}
                              </Form.Group>
                            </Col>
                            <div className="gap-2d-flex">
                              {isExistingBidRes ?
                                <div className="">
                                  <div
                                    className=" text-primary cursor-pointer"
                                    style={Fontstyling.label}
                                    onClick={() => onDownloadExistBidCsv("Existing_Bidder_Response.csv")}
                                  >
                                    Download Existing Bidder Response
                                  </div>
                                </div>
                                : isSaveDisabled.current ?
                                  <div className="" >
                                    <a
                                      className=" text-decoration-none"
                                      href="/samplefile/rfp_Bidder_info_template.csv"
                                      style={Fontstyling.label}
                                      download
                                    >
                                      Download Bidder Response Template
                                    </a>
                                  </div>
                                  : ""}
                            </div>
                          </Row>
                          {(user?.UserRole === 'Admin' || user?.UserRole === 'Pharmacy') && <Formik
                            innerRef={addNewQuesListFormikRef}
                            enableReinitialize
                            initialValues={initlValsAddNewQuesList}
                            validationSchema={validationSchemaAddNewQuesList}
                            onSubmit={(values)=>sortAddNewQuesTableData(values.questions, additionalQuesTableData)}
                          >
                            {({ values, handleSubmit, handleChange, handleBlur, errors, touched }) => (
                              <Form onSubmit={handleSubmit} id="new-question-list-form">
                                <Form.Group className="text-start row align-items-center gap-3 mt-4">
                                  <Form.Label
                                    className="text-nowrap col-auto mb-0"
                                    style={Fontstyling.label}
                                  >
                                    Do you need to add additional questions to the Questionnaire?
                                    <Required />
                                  </Form.Label>
                                  <Col className="col-3">
                                    <Form.Select
                                      className="py-1 rounded-0 col"
                                      style={Fontstyling.label}
                                      name="needAdditionalQues"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      disabled={witchAction === "showMoreRFP" || isSubmitDisabled.current}
                                      isInvalid={
                                        errors.needAdditionalQues &&
                                        touched.needAdditionalQues
                                      }
                                      value={values.needAdditionalQues}
                                    >
                                      <option value={""}>Select</option>
                                      <option value={"Yes"}>Yes</option>
                                      <option value={"No"}>No</option>
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                      {errors.needAdditionalQues}
                                    </Form.Control.Feedback>
                                  </Col>
                                </Form.Group>
                                {values.needAdditionalQues === 'Yes' && <>
                                  <div className=" d-flex align-items-center justify-content-between gap-3 mt-4 mb-1">
                                    <p style={Fontstyling.heading} className="my-3">
                                      Additional Questions to Questionnaire
                                    </p>
                                    {witchAction !== 'showMoreRFP' && <button
                                      style={{ ...Fontstyling.savebutton, opacity:isSubmitDisabled.current? 0.5 : 1 }}
                                      type="button"
                                      onClick={(e) => {
                                        addNewQuesListFormikRef.current?.handleSubmit();
                                      }}
                                      disabled={isSubmitDisabled.current}
                                    >
                                      Sort
                                    </button>}
                                  </div>
                                  <Table bordered hover responsive className="mb-0">
                                    <thead style={Fontstyling.label}>
                                      <tr className="text-center align-middle">
                                        <th style={{ minWidth: 100, width: 100, maxWidth: 100 }}>Question #<Required /></th>
                                        <th style={{ minWidth: 200 }}>Question Name</th>
                                        <th style={{ minWidth: 150, width: 150, maxWidth: 150 }}>Question Type</th>
                                        <th style={{ minWidth: 100, width: 100, maxWidth: 100 }}>Required?</th>
                                        <th style={{ minWidth: 100, width: 100, maxWidth: 100 }}>Actions</th>
                                      </tr>
                                    </thead>
                                    <FieldArray name="questions">
                                      {({ push, remove }) => (
                                        <tbody>
                                          {values?.questions?.length > 0 && values?.questions.map((question, index) => (
                                            <tr key={index}>
                                              <td>
                                                <Form.Group>
                                                  <Form.Control
                                                    type="text"
                                                    name={`questions.${index}.questionNumber`}
                                                    placeholder="Que.#"
                                                    className={`form-control form-control-sm text-center ${touched.questions && touched.questions[index]?.questionNumber &&
                                                      errors.questions && errors.questions[index]?.questionNumber
                                                      ? 'is-invalid'
                                                      : ''
                                                      }`}
                                                    style={Fontstyling.label}
                                                    value={values.questions[index]?.questionNumber || ''}
                                                    onChange={handleChange}
                                                    onBlur={(e) => {
                                                      handleBlur(e);
                                                      onChangeQuestionNumber(e, index);
                                                    }}
                                                    isInvalid={touched.questions && touched.questions[index]?.questionNumber && errors.questions && errors.questions[index]?.questionNumber}
                                                    disabled={isSubmitDisabled.current}
                                                  />
                                                  <Form.Control.Feedback type="invalid">
                                                    {errors.questions && errors.questions[index]?.questionNumber}
                                                  </Form.Control.Feedback>
                                                </Form.Group>
                                              </td>
                                              <td style={Fontstyling.label}>
                                                {question.questionLabel}
                                              </td>
                                              <td className='text-center' style={Fontstyling.label}>{JSON.parse(question.questionType).label}</td>
                                              <td className='text-center' style={Fontstyling.label}>{JSON.parse(question.isQuestionRequired).value ? 'Yes' : 'No'}</td>
                                              <td>
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                  <button
                                                    className="btn p-0 m-0 rounded-circle border-0 pe-auto"
                                                    type="button"
                                                    onClick={(e) => {
                                                      setSelectedQuestion({ question, index });
                                                      setShowAddQuesModal(true);
                                                      setIsQuestionsShorted(false);
                                                    }}
                                                    disabled={witchAction === 'showMoreRFP' || isSubmitDisabled.current}
                                                  >
                                                    <img src={editIcon} />
                                                  </button>
                                                  <button
                                                    className="btn p-0 m-0 ms-1 rounded-circle border-0 pe-auto"
                                                    type="button"
                                                    onClick={(e) => {
                                                      setShowDeleteNewQueModal((prev)=> ({...prev, isShowModal: true}));
                                                      setSelectedQuestion({ question, index });
                                                    }}
                                                    disabled={witchAction === 'showMoreRFP' || isSubmitDisabled.current}
                                                  >
                                                    <img src={deleteIcon} width={15} />
                                                  </button>
                                                </div>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      )}
                                    </FieldArray>
                                  </Table>
                                  {errors.questions && typeof errors.questions === 'string' && touched.questions && <div className="invalid-feedback d-block">
                                    {errors.questions}
                                  </div>}

                                <div className="d-flex align-items-center justify-content-between my-3">
                                  {witchAction === 'showMoreRFP' ?
                                    <div></div> :
                                    <button
                                      style={{ ...Fontstyling.savebutton, textTransform: "initial", opacity:isSubmitDisabled.current? 0.5 : 1 }}
                                      type="button"
                                      onClick={(e) => {
                                        setShowAddQuesModal(true);
                                        setIsQuestionsShorted(false);
                                      }}
                                      disabled={isSubmitDisabled.current}
                                    >
                                      Add a New Question
                                    </button>}
                                    <button
                                      style={{ ...Fontstyling.savebutton, pointerEvents: 'initial' }}
                                      type="button"
                                      onClick={(e) => {
                                        setShowQuePreviewModal(true);
                                      }}
                                    >
                                      Preview
                                    </button>
                                  </div>

                                </>}
                              </Form>
                            )}
                          </Formik>}
                        </>
                      )}
                    {isLoading ? (
                      <div className="d-flex justify-content-center align-items-center">
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="false"
                          style={{ marginRight: "5px" }}
                        />
                        <span>Loading...</span>
                      </div>
                    ) : (
                      ""
                    )}
                    {witchAction !== "showMoreRFP" &&
                      <div className=" d-flex align-items-center justify-content-end gap-3 my-4 ">
                        <button
                          style={{ ...Fontstyling.savebutton, opacity:isSaveDisabled.current? 0.5 : 1 }}
                          type="submit"
                          disabled={isSaveDisabled.current}
                          onClick={(e) => {
                            const bidderAdd = document.getElementById("bidderinfo");
                            bidderAdd?.click();
                            handleValidationError()
                           
                          }}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          style={{...Fontstyling.savebutton, opacity:!isSubmitDisabled.current? 1 :0.5 }}
                          disabled={isSubmitDisabled.current}
                          onClick={onSubmitHandler}
                        >
                          Send Request for Proposal
                        </button>

                        <button
                          style={Fontstyling.cancelbutton}
                          type="reset"
                          onClick={(e) => {
                            setShowModal(false);
                            setShowTable(true)
                            // document.getElementById('bidderinfo').style.display = 'none';
                          }}
                          disabled={isLoading && (isSaveDisabled.current || isSubmitDisabled.current)}
                        >
                          Close
                        </button>
                      </div>
                    }
                  </Form>
                );
              }}
            </Formik>
          )}
        </Modal.Body>
        
      </Modal>}
      <ConfirmModal
        ifYes={() => {
          if(showDeleteNewQueModal.confirmStep === 0) {
            setShowDeleteNewQueModal((prev) => ({ ...prev, confirmStep: 1 }));
          } else {
            onDeleteNewQues();
          }
        }}
        show={showDeleteNewQueModal.isShowModal}
        closeModal={closeQueDeleteModal}
        massage={showDeleteNewQueModal.confirmStep === 0 ? "You have selected to delete this question from the questions. Do you want to proceed?": "By deleting this question, all question related information will be deleted as well. This action is not reversable. Do you want to Proceed?"}
      />
      <Modal
        show={showAddQuesModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
        size={witchAction !== "delete" ? "xl" : "md"}
      >
        <Modal.Header
          closeButton
          onHide={() => {
            setShowAddQuesModal(false);
            setSelectedQuestion(null);
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{...Fontstyling.modalHeading, textTransform: 'initial'}}
          >
            {selectedQuestion ? "Update Question" : "Add a New Question"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            validationSchema={addQuesModalSchema}
            onSubmit={onSubmitAddNewQuestion}
            initialValues={{
              id: selectedQuestion?.question.id ?? null,
              questionNumber: selectedQuestion?.question.questionNumber ?? addNewQuesListFormikRef?.current?.values?.questions.length + 1,
              questionLabel: selectedQuestion?.question.questionLabel ?? "",
              questionHelperText: selectedQuestion?.question.questionHelperText ?? "",
              questionType: selectedQuestion?.question.questionType ?? "",
              dropdownType: selectedQuestion?.question.dropdownType ?? "",
              dropdownValues: selectedQuestion?.question.dropdownValues ?? "",
              explanationRequired: selectedQuestion?.question.explanationRequired ?? "",
              dropdownValuesRequireExplanation: selectedQuestion?.question.dropdownValuesRequireExplanation ?? "",
              isQuestionRequired: selectedQuestion?.question.isQuestionRequired ?? "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              setFieldValue,
              setValues,
              values,
              touched,
              isValid,
              errors,
              resetForm
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <div>
                   
                    <Col>
                      <Form.Group className="row align-items-center mb-3">
                        <Form.Label
                          className="text-nowrap mb-0 col-4"
                          style={Fontstyling.label}
                        >
                          Is this question Required?<Required />
                          <img
                            data-tip="Does this question require a response or can a vendor skip it?"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                        </Form.Label>
                        <Col className="col-2">
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="isQuestionRequired"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.isQuestionRequired}
                            isInvalid={errors.isQuestionRequired && touched.isQuestionRequired}
                          >
                            <option value={''}>Select</option>
                            {[
                              { label: 'Yes', value: true },
                              { label: 'No', value: false },
                            ].map((item, index) => (
                              <option
                              key={index}
                              value={JSON.stringify(item)}
                              >
                              {item.label}
                            </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.isQuestionRequired}
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>
                    </Col>                                      
                    <Col>
                      <Form.Group className="row align-items-center mb-3">
                        <Form.Label
                          className="text-nowrap mb-0 col-4"
                          style={Fontstyling.label}
                        >
                          Question Type<Required />
                          <img
                            data-tip="free text (text volume is limited) v.text area (text volume is not limited) and number (digits,integers) v.amount ($ sign)"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                        </Form.Label>
                        <Col className="col-2">
                          <Form.Select
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            name="questionType"
                            onChange={(e)=> {
                              handleChange(e);
                              let val = e.target.value;
                              if (val && JSON.parse(val).label !== "Drop-Down") {
                                setFieldValue('dropdownType', '');
                                setFieldValue('dropdownValues', '');
                                setFieldValue('explanationRequired', '');
                                setFieldValue('dropdownValuesRequireExplanation', '');
                              }
                            }}
                            onBlur={handleBlur}
                            value={values.questionType}
                            isInvalid={errors.questionType && touched.questionType}
                          >
                            <option value={''}>Select</option>
                            {[
                              {label: 'Free Text', value: 'text', type: 'text'},
                              {label: 'Text-Area', value: 'textarea', type: 'textarea'},
                              {label: 'Number', value: 'number', type: 'text'},
                              {label: 'Amount', value: 'isAmount', type: 'text'},
                              {label: 'Percentage', value: 'isPercentage', type: 'text'},
                              {label: 'Drop-Down', value: 'dropdown', type: 'dropdown'},
                            ].map((item, index) => (
                              <option
                                key={index}
                                value={JSON.stringify(item)}
                              >
                                {item.label}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.questionType}
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>
                    </Col>
                    {values?.questionType && JSON.parse(values.questionType)?.label === 'Drop-Down' && <>
                      <Col>
                        <Form.Group className="row align-items-center mb-3">
                          <Form.Label
                            className="text-nowrap mb-0 col-4"
                            style={Fontstyling.label}
                          >
                            Drop-Down Type<Required />
                          </Form.Label>
                          <Col className="col-2">
                            <Form.Select
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              name="dropdownType"
                              onChange={(e) => {
                                handleChange(e);
                                let value = e.target.value;
                                if (value && JSON.parse(value).label === "Yes/No") {
                                  setFieldValue('dropdownValues', 'Yes,No');
                                } else {
                                  setFieldValue('dropdownValues', '');
                                }
                              }}
                              onBlur={handleBlur}
                              value={values.dropdownType}
                              isInvalid={errors.dropdownType && touched.dropdownType}
                            >
                              <option value={''}>Select</option>
                              {
                                [
                                  { label: 'Yes/No', value: 'Yes/No', type: 'dropdown' },
                                  { label: 'Single Select', value: 'Single Select', type: 'dropdown' },
                                  { label: 'Multiple Select', value: 'Multiple Select', type: 'multiSelectDropdown' },
                                ].map((item, index) => (
                                  <option
                                    key={index}
                                    value={JSON.stringify(item)}
                                  >
                                    {item.label}
                                  </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.dropdownType}
                            </Form.Control.Feedback>
                          </Col>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="row align-items-center mb-3">
                          <Form.Label
                            className="text-nowrap mb-0 col-4"
                            style={Fontstyling.label}
                          >
                            Drop-Down Values
                            <Required />
                            <p className="text-danger fw-bold mb-0" style={Fontstyling.label}>Please list all drop-down values, seperated with ",".</p>
                          </Form.Label>
                          <Col>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              name="dropdownValues"
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              value={values.dropdownValues}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.dropdownValues &&
                                errors.dropdownValues
                              }
                              placeholder="Long text"
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.dropdownValues}
                            </Form.Control.Feedback>
                          </Col>
                        </Form.Group>
                      </Col>
                      {values?.dropdownType && JSON.parse(values.dropdownType)?.type === 'dropdown' && <>
                        <Col>
                          <Form.Group className="row align-items-center mb-3">
                            <Form.Label
                              className="text-nowrap mb-0 col-4"
                              style={Fontstyling.label}
                            >
                              Explanation Required?<Required />
                            </Form.Label>
                            <Col className="col-2">
                              <Form.Select
                                className="py-1 rounded-0"
                                style={Fontstyling.label}
                                name="explanationRequired"
                                onChange={(e) => {
                                  handleChange(e);
                                  setFieldValue('dropdownValuesRequireExplanation', '');
                                }}
                                onBlur={handleBlur}
                                value={values.explanationRequired}
                                isInvalid={errors.explanationRequired && touched.explanationRequired}
                              >
                                <option value={''}>Select</option>
                                {[
                                  { label: 'Yes', value: 'Yes' },
                                  { label: 'No', value: '-1' },
                                ].map((item, index) => (
                                  <option
                                    key={index}
                                    value={JSON.stringify(item)}
                                  >
                                    {item.label}
                                  </option>
                                ))}
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {errors.explanationRequired}
                              </Form.Control.Feedback>
                            </Col>
                          </Form.Group>
                        </Col>
                        {values?.explanationRequired && JSON.parse(values.explanationRequired)?.label === 'Yes' &&
                          <Col>
                            <Form.Group className="row align-items-center mb-3">
                              <Form.Label
                                className="text-nowrap mb-0 col-4"
                                style={Fontstyling.label}
                              >
                                Drop-Down Value(s) require Explanation
                                <Required />
                                <p className="text-danger fw-bold mb-0" style={Fontstyling.label}>Please list all drop-down values, seperated with ",".</p>
                              </Form.Label>
                              <Col>
                                <Form.Control
                                  as="textarea"
                                  rows={2}
                                  name="dropdownValuesRequireExplanation"
                                  className="py-1 rounded-0"
                                  style={Fontstyling.label}
                                  value={values.dropdownValuesRequireExplanation}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.dropdownValuesRequireExplanation &&
                                    errors.dropdownValuesRequireExplanation
                                  }
                                  placeholder="Long text"
                                />
                                <Form.Control.Feedback type="invalid">
                                  {errors.dropdownValuesRequireExplanation}
                                </Form.Control.Feedback>
                              </Col>
                            </Form.Group>
                          </Col>
                        }
                      </>}
                    </>}
                    <Col>
                      <Form.Group className="row align-items-center mb-3">
                        <Form.Label
                          className="text-nowrap mb-0 col-4"
                          style={Fontstyling.label}
                        >
                          Question
                          <Required />
                        </Form.Label>
                        <Col>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="questionLabel"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.questionLabel}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.questionLabel &&
                              errors.questionLabel
                            }
                            placeholder="Long text"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.questionLabel}
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="row align-items-center mb-3">
                        <Form.Label
                          className="text-nowrap mb-0 col-4"
                          style={Fontstyling.label}
                        >
                          Question Helper Text
                          <img
                            data-tip="This is an optional feature to explain or contextualize the question"
                            src={require("../../../assets/icon/Question_mark_back.png")}
                            style={{ height: 15, marginLeft: 3 }}
                          />
                          <ReactTooltip
                            className="border-2 border-info p-3"
                            border
                            backgroundColor="white"
                            textColor="black"
                          />
                        </Form.Label>
                        <Col>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            name="questionHelperText"
                            className="py-1 rounded-0"
                            style={Fontstyling.label}
                            value={values.questionHelperText}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.questionHelperText &&
                              errors.questionHelperText
                            }
                            placeholder="Long text"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.questionHelperText}
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>
                    </Col> 
                    <Col>
                      <Form.Group className="row align-items-center mb-3">
                        <Form.Label
                          className="text-nowrap mb-0 col-4"
                          style={Fontstyling.label}
                        >
                          Question Number<Required />                        
                        </Form.Label>                        
                        <Col>
                          <Form.Control
                            className="py-1 rounded-0"
                            style={{ ...Fontstyling.label, width: 150 }}
                            name="questionNumber"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.questionNumber}
                            isInvalid={errors.questionNumber && touched.questionNumber}
                            placeholder="Question Number"
                            disabled
                          >
                          </Form.Control>
                          <Form.Control.Feedback type="invalid">
                            {errors.questionNumber}
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>
                    </Col>                                     
                  </div>
                  <div className="d-flex align-items-center gap-3 mt-5 mb-4">
                    <button
                      style={{ ...Fontstyling.savebutton }}
                      type="submit"
                    >
                      Save
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>

      <Modal
        show={showQuePreviewModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="modal-85w"
        scrollable
      >
        <Modal.Header
          closeButton
          onHide={() => {
            setShowQuePreviewModal(false);
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            Additional Questions Preview
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RfpAdditionalQuestions additionalQuesTableData={additionalQuesTableData} formik={formikPreviewQuestions} />
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{ ...Fontstyling.cancelbutton }}
            type="button"
            onClick={() => setShowQuePreviewModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <div className="d-flex align-item-center justify-content-between py-3 border-bottom">
        <div style={Fontstyling.heading}>List of Pharmacy Marketing Request</div>
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
            setisDisable(false)
          }}
        >
          Add Pharmacy Marketing Request
        </CustomButton>
      </div>
      {showTable && (<CustomMaterialTable
        overrideColumn={column}
        data={(query) =>
          new Promise((resolve, reject) => {
            setIsLoading(true);
            GetListofEmpowerxRfp(
              "",
              query?.search,
              query?.pageSize,
              query?.page
            ).then((result) => {
              resolve({
                data: result?.data?.data?.empowerxRfpList ? result?.data?.data?.empowerxRfpList : [] ,
                page: query.page,
                totalCount: result?.data?.data?.totalPages * query.pageSize,
              });
              setIsLoading(false)
            });
          })
        }
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
        isExport={false}
      />)}
      <Modal show={showFinalWinnerConfirmModal} onHide={()=>setShowFinalWinnerConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>You have selected a final winner. Once it’s saved, you cannot change it anymore. Do you want to proceed?</Modal.Body>
        <Modal.Footer>
          <Button
            style={Fontstyling.savebutton}
            onClick={() => {
              finalWinnerFormikRef.current?.handleSubmit();
              setShowFinalWinnerConfirmModal(false);
            }}
          >
            Yes
          </Button>
          <Button
            style={Fontstyling.cancelbutton}
            onClick={closeFinalWinnerModal}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EmpoweRX;

const BidderInfoTableRow = ({
  row,
  rowInd,
  bidderTableData,
  setBidderTableData,
  onRowDelete,
  onSaveIconClick,
  inpRef,
  formikRef,
  witchAction,
  stateList,
  bidderEdit,
  setBidderEdit,
  isSaveDisabled
}) => {

  const [canEdit, setCanEdit] = useState(false);
  const [actionBtnsEnabled, setActionBtnsEnabled] = useState(true);
  const { isEdit, editRowInd } = bidderEdit;
  const isLastRow = rowInd === bidderTableData.length - 1;
  const isBlankRowAvailable = isLastRow? row.dummyId === undefined : false;
  const {
    id,
    dummyId,
    bidderCompanyName,
    bidderContactName,
    bidderContactEmail,
    bidderContactPhone,
    jobTitle,
    mailingAddress,
    city,
    state,
    zip
  } = row;
  const initialValues = {
    bidderCompanyName: bidderCompanyName ?? "",
    bidderContactName: bidderContactName ?? "",
    bidderContactEmail: bidderContactEmail ?? "",
    bidderContactPhone: bidderContactPhone ?? "",
    jobTitle: jobTitle ?? "",
    mailingAddress: mailingAddress ?? "",
    city: city ?? "",
    state: state ?? "",
    zip: zip ?? "",
  };
  const tblSchema = Yup.object().shape({
    bidderCompanyName: Yup.string().trim().required('Required'),
    bidderContactName: Yup.string().trim().required('Required'),
    bidderContactPhone: Yup.string().trim().required('Required'),
    bidderContactEmail: Yup.string()
    .test(
      'is-email',
      'Invalid email',
      (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    )
    .test(
      'unique-company-email',
      'Email already exists',
      function (value) {
        const { bidderCompanyName } = this.parent; 
        const duplicateIndex = bidderTableData.findIndex(
          (bid, index) => (
            index !== editRowInd && bid.bidderContactEmail === value && bid.bidderCompanyName === bidderCompanyName)
        );

        if (duplicateIndex !== -1) {
          return false;
        }
        return true;
      }
    ),
    jobTitle: Yup.string().trim().required('Required'),
    // mailingAddress: Yup.string().trim().required('Required'),
    // city: Yup.string().trim().required('Required'),
    // state: Yup.string().trim().required('Required'),
    zip: Yup.string()
    .trim()
    .matches(/^[0-9-]+$/, 'Only numbers and hyphens are allowed'),
    
  });

  useEffect(() => {
    if(witchAction === "showMoreRFP" || isSaveDisabled.current){
      setCanEdit(false);
      setActionBtnsEnabled(false);
    }
    else if (isEdit) {
      if (editRowInd === rowInd) {
        setCanEdit(true);
        setActionBtnsEnabled(true);
      }
      else {setCanEdit(false); 
        setActionBtnsEnabled(false);
      }
    }
    else { 
      if (isLastRow && !dummyId) {
        setCanEdit(true);
      }else{
        setCanEdit(false)
      }
      setActionBtnsEnabled(true) }
  }, [bidderEdit, bidderTableData])

  return (
    <Formik
      innerRef={formikRef}
      key={dummyId}
      enableReinitialize
      validationSchema={tblSchema}
      onSubmit={(vals, hand) => {
        onSaveIconClick(vals, hand, dummyId , rowInd , row);
      }}
      initialValues={initialValues}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        setFieldValue,
        resetForm
      }) => (
        <tr style={witchAction === "showMoreRFP" ? { pointerEvents: "none" } : {}}>
          <td>
            <Form.Group>
              <Form.Control
                className="rounded-0 py-1"
                style={{ ...Fontstyling.label, minWidth: "70px" }}
                type="text"
                placeholder="Bidder Company Name"
                name="bidderCompanyName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.bidderCompanyName}
                isInvalid={touched.bidderCompanyName && errors.bidderCompanyName}
                maxLength={100}
                ref={inpRef}
                disabled={!canEdit}
              />
              <Form.Control.Feedback type="invalid">
                {errors.bidderCompanyName}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group>
              <Form.Control
                className="rounded-0 py-1"
                style={{ ...Fontstyling.label, minWidth: "70px" }}
                type="text"
                placeholder="Bidder Contact Name"
                name="bidderContactName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.bidderContactName}
                isInvalid={touched.bidderContactName && errors.bidderContactName}
                maxLength={100}
                disabled={!canEdit}
              />
              <Form.Control.Feedback type="invalid">
                {errors.bidderContactName}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group>
              <Form.Control
                className="rounded-0 py-1"
                style={{ ...Fontstyling.label, minWidth: "70px" }}
                type="email"
                placeholder="Bidder Contact Email"
                name="bidderContactEmail"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.bidderContactEmail}
                isInvalid={touched.bidderContactEmail && errors.bidderContactEmail}
                maxLength={100}
                disabled={!canEdit}
              />
              <Form.Control.Feedback type="invalid">
                {errors.bidderContactEmail}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group>
              <Form.Control
                className="rounded-0 py-1"
                style={{ ...Fontstyling.label, minWidth: "70px" }}
                type="text"
                placeholder={"Bidder Contact Phone"}
                name="bidderContactPhone"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.bidderContactPhone}
                isInvalid={touched.bidderContactPhone && errors.bidderContactPhone}
                maxLength={30}
                disabled={!canEdit}
              />
              <Form.Control.Feedback type="invalid">
                {errors.bidderContactPhone}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group>
              <Form.Control
                className="rounded-0 py-1"
                style={{ ...Fontstyling.label, minWidth: "70px" }}
                type="text"
                placeholder={"Job Title"}
                name="jobTitle"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.jobTitle}
                isInvalid={touched.jobTitle && errors.jobTitle}
                maxLength={100}
                disabled={!canEdit}
              />
              <Form.Control.Feedback type="invalid">
                {errors.jobTitle}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group>
              <Form.Control
                className="rounded-0 py-1"
                style={{ ...Fontstyling.label, minWidth: "70px" }}
                type="text"
                placeholder={"Mailing Address"}
                name="mailingAddress"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.mailingAddress}
                isInvalid={touched.mailingAddress && errors.mailingAddress}
                maxLength={100}
                disabled={!canEdit}
              />
              <Form.Control.Feedback type="invalid">
                {errors.mailingAddress}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td>
            <Form.Group>
              <Form.Control
                className="rounded-0 py-1"
                style={{ ...Fontstyling.label, minWidth: "70px" }}
                type="text"
                placeholder={"City"}
                name="city"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.city}
                isInvalid={touched.city && errors.city}
                maxLength={100}
                disabled={!canEdit}
              />
              <Form.Control.Feedback type="invalid">
                {errors.city}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td >
              <Form.Group>
                <Form.Select
                  className="py-1 rounded-0"
                  style={{ ...Fontstyling.label, minWidth: "120px" }}
                  name="state"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={!canEdit}
                  isInvalid={
                    values.state === "" &&
                    errors.state &&
                    touched.state
                  }
                  value={values.state}
                >
                <option value={""}>Select State </option>
                {stateList.map(({ state }) => (
                  <option value={state}>{state}</option>
                ))}
              </Form.Select>
              {errors.state && touched.state && (
                <Form.Label style={Fontstyling.errorlabel}>
                  {errors.state}
                </Form.Label>
              )}
              </Form.Group>
          </td>
          <td>
            <Form.Group>
              <Form.Control
                className="rounded-0 py-1"
                style={{ ...Fontstyling.label, minWidth: "70px" }}
                type="text"
                placeholder={"Zip"}
                name="zip"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.zip}
                isInvalid={touched.zip && errors.zip}
                maxLength={30}
                disabled={!canEdit}
              />
              <Form.Control.Feedback type="invalid">
                {errors.zip}
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td className="px-1 text-center" xs={6}>
            <div className="d-flex align-items-center justify-content-center gap-2" >
              {
              // !dummyId ? <button
              //   className="btn p-0 m-0 rounded-circle border-0"
              //   type="submit"
              //   id={actionBtnsEnabled?"bidderinfo":""}
              //   // disabled={rowInd !== bidderTableData.length - 1 || witchAction === "showMoreRFP"}
              //   disabled={!actionBtnsEnabled}
              //   onClick={(e) => {
              //     handleSubmit(e);
              //     e.preventDefault();
              //     // setBidderFormikErrors(formikRef?.current?.errors);
              //   }}
              // >
              //   <MdAddCircle size={19} />
              // </button>:
              canEdit ? (
                <button
                  className="btn p-0 m-0 rounded-circle border-0"
                  type="submit"
                  id={actionBtnsEnabled?"bidderinfo":""}
                  onClick={(e) => {
                    handleSubmit(e);
                    e.preventDefault();
                  }}
                  disabled={!actionBtnsEnabled}
                  >
                  <IoCheckmarkCircle size={23} />
                </button>
              ) : (
                <button
                  className="btn p-0 m-0 rounded-circle border-0 pe-auto"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    setBidderEdit({isEdit:true, editRowInd:rowInd});
                  }}
                  disabled={!actionBtnsEnabled}
                  >
                  <img src={editIcon} />
                </button>
              )}
              <button
                className="btn p-0 m-0 ms-1 rounded-circle border-0 pe-auto"
                type="button"
                onClick={(e) => {
                  onRowDelete(dummyId , rowInd, id);
                }}
                disabled={!actionBtnsEnabled}
              >
                <img src={deleteIcon} width={15} />
              </button>
              {isLastRow && dummyId && !isEdit && witchAction !== 'showMoreRFP' && <button
                className="btn p-0 m-0 rounded-circle border-0"
                type="button"
                onClick={(e) => {
                  setBidderTableData([...bidderTableData, {}]);
                }}
                disabled={isEdit || isSaveDisabled.current}
              >
                <MdAddCircle size={20} />
              </button>}
            </div>
          </td>
        </tr>
      )}
    </Formik>
  );
};


